<script lang="ts">
  import { onMount, onDestroy, setContext, getContext } from "svelte";
  import { fly, slide } from "svelte/transition";
  import { quintOut } from "svelte/easing";
  import LeftMenu from "../../LeftMenu.svelte";
  import DrawingCanvas from "../../DrawingCanvas.svelte";
  import prepareAssets, { fetchFont } from "../../utils/prepareAssets.js";
  import {
    readAsArrayBuffer,
    readAsImage,
    readAsPDF,
    readAsDataURL,
  } from "../../utils/asyncReader.js";
  import { ggID, timeout } from "../../utils/helper.js";
  import { save, getData, getPdfPageData } from "../../utils/PDF.js";
  import Background from "../../Background.svelte";
  import Carousel from "../../Carousel.svelte";
  import CheckMark from "../../CheckMark.svelte";
  import CopyClipBoard from "../../CopyClipBoard.svelte";
  import SendTo from "../../SendTo.svelte";

  import Packets from "../../Packets.svelte";

  let packetsRef;

  import {
    user as storeUser,
    auth,
    logout,
    sendBase64FileToGoogleDrive,
    sendBase64FileToOneDrive,
    getChatUsers,
    getTeam,
  } from "../../store/auth.store";
  import { timeAgo } from "../../store/timeAgo.js";

  import ImageUploader from "../../ImageUploader.svelte";
  import PdfTemplate from "../../Template.svelte";
  import SubscribeView from "../../SubscribeView.svelte";
  import PageToolbar from "../../PageToolbar.svelte";
  import ShareFlow from './components/share/ShareFlow.svelte';
  import SignContextMenu from './components/menus/SignContextMenu.svelte';
  import SignEditorHeader from './components/layout/SignEditorHeader.svelte';
  import SignPreviewHeader from './components/layout/SignPreviewHeader.svelte';
  import SignLoginPanel from './components/layout/SignLoginPanel.svelte';
  import SignPdfEditor from './components/layout/SignPdfEditor.svelte';
  import { subscribeIsMobile } from './utils/media.js';
  import { buildSignUrl, toPublicSignUrl, QIX_ORIGIN } from '../../utils/signPublicUrl.js';

  let isMobile = false;
  let getStartedOpen = false;
  let getStartedCarouselReady = false;
  let getStartedCarouselKey = 0;
  const unsubscribeMobile = subscribeIsMobile((v) => {
    isMobile = v;
  });
  onDestroy(() => {
    if (unsubscribeMobile) unsubscribeMobile();
  });

  function toggleGetStarted() {
    if (getStartedOpen) {
      getStartedOpen = false;
      getStartedCarouselReady = false;
      return;
    }
    getStartedOpen = true;
  }

  function onGetStartedIntroEnd() {
    getStartedCarouselReady = true;
    getStartedCarouselKey += 1;
    // Let Siema measure after the accordion finishes opening + layout
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize"));
        setTimeout(() => window.dispatchEvent(new Event("resize")), 50);
      });
    });
  }

  function onGetStartedOutroStart() {
    getStartedCarouselReady = false;
  }

  // Test/demo mode flag (dummy data applied after variable declarations)
  const mockMode =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('mockUser') === '1';

  // Capture preview query params immediately (before auth can alter/clean the URL),
  // and also check parent frame — legalpal.app may embed this app in an iframe.
  function readPreviewQueryParams() {
    const empty = { contactPost: null, signedContact: null };
    if (typeof window === 'undefined') return empty;
    try {
      const params = new URLSearchParams(window.location.search);
      let contactPost = params.get('contactPost');
      let signedContact = params.get('signedContact');

      if ((!contactPost || !signedContact) && window.parent && window.parent !== window) {
        try {
          const parentParams = new URLSearchParams(window.parent.location.search);
          contactPost = contactPost || parentParams.get('contactPost');
          signedContact = signedContact || parentParams.get('signedContact');
        } catch (_) {
          // cross-origin parent
        }
      }

      return { contactPost, signedContact };
    } catch (_) {
      return empty;
    }
  }

  const bootPreviewParams = readPreviewQueryParams();
  if (typeof window !== 'undefined') {
    try {
      if (bootPreviewParams.signedContact) {
        sessionStorage.setItem('signPreview_signedContact', bootPreviewParams.signedContact);
      }
      if (bootPreviewParams.contactPost) {
        sessionStorage.setItem('signPreview_contactPost', bootPreviewParams.contactPost);
      }
    } catch (_) {}
  }

  console.log('Sign boot URL', typeof window !== 'undefined' ? window.location.href : '', bootPreviewParams);

  const genID = ggID();
  let searchTutorial = "";
  let emailSubject = "";
  let emailCC = "";
  let pdfFile;
  let pdfFiles = [];
  let pdfBlobFile = "";
  let pdfName = "";
  let completedPDFUrl = "";
  let pages = [];
  let pagesScale = [];
  let allObjects = [];
  let currentFont = "Times-Roman";
  let focusId = null;
  let selectedPageIndex = -1;
  let saving = false;
  let sending = false;
  let addingDrawing = false;
  let users = [];
  let chatUsers = [];
  let selectedUser = "";
  let smsSelectedUser = "";
  let selectedChatUser = "";
  let usersPanel = false;
  let loginPanel = false;
  let tutorialPanel = false;
  let uploadToFluentCase = false;
  let uploadedToFluentCase = false;
  let user_name = "";
  let user_pw = "";
  let user_data = [];
  let loginError = "";
  let showMenu = false;
  let pos = { x: 0, y: 0 };
  let layerPos = { x: 0, y: 0 };
  let wx = 0;
  let wy = 0;
  let quickSigns = [];
  let showSignatureTab = false;
  let signatureTabLoading = true;
  let selectedSginTab = "pending";
  let pendingSignature = [];
  let completedSignature = [];
  let completedArchived = [];
  let templates = [];
  let sendingSign = false;
  let firstLoading = false;
  let sharePanel = false;
  let signatureMenu = false;
  let logoutpanel = false;
  let sendPDFType = "";
  let sendPDFRes = false;
  let clipboardTxt = "";
  let blog_slug = "";
  let loginOnly = true;
  let searchKeyPending = "";
  let searchKeyCompleted = "";
  let searchKeySignature = "";
  let newUserPanel = false;
  let userName = "";
  let userPhone = "";
  let newProfilePanel = false;
  let defaultDocs = [
    "CLIENT-Forwarding_Consent_Forms_for_MSA_SSDI_-_Settlement.pdf",
    "Fee_Disclosure_Statement.pdf",
    "intake_dwc-1.docx.pdf",
    "INTAKE_imr_rule.pdf",
    "INTAKE_LABOR_CODE_SECTION_4906_g.pdf",
    "intake_new_client_part3.pdf",
    "INTAKE_VENUE.pdf",
    "INTAKE_Warning_To_Employee_Letter.pdf",
  ];
  let sendingNewUser = false;
  let sendingNewUserType = 0;
  let templateId = 0;
  let showRenameTemp = false;
  let newTempName = "";
  let tempThumb = "";
  let newSignPanel = false;
  let newSignName = "";
  let newSignPhone = "";
  let twoFactAuthPanel = false;
  let verificationCode = "";
  let user_data_temp = "";
  let display_name_panel = false;
  let newUserName = "";
  let friends = [];


  let searchKeyFriend = "";
  let inviteFriendPanel = false;
  let inviteFriendEmail = "";
  let tutorialStep = 0;
  let tutorialNumber = 0;

  let inviteClipboardTxt = "";
  let pdfWrap;
  let smsLang = "";
  let languages = [
    { value: "en", label: "English" },
    { value: "sp", label: "Spanish" },
    { value: "ko", label: "Korean" },
    { value: "ch", label: "Chinese" },
    { value: "Fr", label: "French" },
  ];
  let smsSign = "";
  let signColor = 0;
  let displayLeftMenu = false;
  let sendToId = 0;
  let emailPanel = false;
  let emailCCPanel = false;
  let shareEmail = "";
  let shareUserId = "";
  let shareUserName = "";
  let shareCaseFileId = "";
  let shareEmailcc = "";
  let checkIfEmail = false;
  let shortName = "";
  let merusToken = "";
  let fluentCaseToken = '';
  let blog = { siteurl: QIX_ORIGIN };
  let signUrl = "";
  let logo = "/img/default_image.svg";
  let emailNotifyAvailable = true;
  let teamViewCompletedDocAvailable = false;
  let shareSettingsAvailable = false;
  let editTemplatesAvailable = false;
  let selectedMerusUserId = "";
  let selectedMerusActivityTypeId = "";
  let selectedFluentCaseTagId = "";
  let selectedSharepoint = "";
  let selectedEventType = "";
  let selectedEventNumberOfDays = "";
  let matterId = "";
  let user = {
    id: "",
    appId: "",
    email: "",
    name: "",
    surname: "",
    img: "",
    phone: "",
    role: "",
    locale: "",
    loggedIn: "", // optional
    google: "", // optional
    microsoft: "",
    merusCaseEnabled: false,
    fileVineEnabled: false, // optional
    fluentCaseEnabled: false // optional
  };

  $: if ($storeUser) {
    user = $storeUser;
  }

  if (mockMode) {
    user = {
      id: 'user-1',
      appId: '4391ab602e9c8d89b03cdb30fa7fa99a',
      email: 'mahmoud.naoum.longemail@legalpal.app',
      name: 'Mahmoud',
      surname: 'Naoum Longname',
      img: '',
      phone: '+15555550100',
      role: 'admin',
      locale: 'en',
      loggedIn: true,
      google: true,
      microsoft: false,
      merusCaseEnabled: true,
      fileVineEnabled: false,
      fluentCaseEnabled: true,
      subscribed: true,
      signinCount: 1,
    };
    users = [
      {
        id: 'chat-1',
        fullName: 'Jane Client',
        email: 'jane@example.com',
        phone: '15555550123',
      },
    ];
    chatUsers = [
      {
        id: 'chat-1',
        fullName: 'Erik test',
        email: 'erikhyndman.very.long.email@example.com',
        phone: '+15105668844',
        language: 'us',
        advanced: { caseFileIds: [] },
        fluentCaseMattersIds: [],
        events: [],
        assignedTo: ['friend-2', 'friend-3'],
      },
      {
        id: 'chat-2',
        fullName: 'Richard (Rick) Herron Longname',
        email: 'richard.rick.herron@example-lawfirm.com',
        phone: '15555550999',
        language: 'us',
        advanced: { caseFileIds: ['cf-long-1'] },
        fluentCaseMattersIds: [],
        events: [],
        assignedTo: ['user-1'],
      },
      {
        id: 'chat-3',
        fullName: 'Jane Client',
        email: 'jane@example.com',
        phone: '15555550123',
        language: 'us',
        advanced: { caseFileIds: ['cf-1'] },
        fluentCaseMattersIds: [],
        events: [],
        assignedTo: [],
      },
    ];
    pendingSignature = [
      {
        id: 'p1',
        attachmentName:
          'Pay & More, Online Pay Taxes, Utility Bills, Active Documents to Sign Final.pdf',
        attachmentUrl: 'https://qix.cloud/mock/nda.pdf',
        created: Date.now() - 3600000,
        author_id: 'chat-1',
        author_email: 'erikhyndman.very.long.email@example.com',
        user_name_pending: 'Erik test',
        date: '07/30/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p2',
        attachmentName: 'Fee Disclosure Statement.pdf',
        attachmentUrl: 'https://qix.cloud/mock/fee.pdf',
        created: Date.now() - 7200000,
        author_id: 'chat-1',
        author_email: 'mobile.test@legalpal.app',
        user_name_pending: 'Alex Morgan',
        date: '07/30/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p3',
        attachmentName: 'PI Short Form Auto (Adult - English).pdf',
        attachmentUrl: 'https://qix.cloud/mock/nda2.pdf',
        created: Date.now() - 86400000 * 2,
        author_id: 'chat-1',
        author_email: 'mobile.test@legalpal.app',
        user_name_pending: 'Erik Hyndman',
        date: '07/28/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p4',
        attachmentName: 'Medical Authorization Form.pdf',
        attachmentUrl: 'https://qix.cloud/mock/med.pdf',
        created: Date.now() - 86400000 * 2 - 3600000,
        author_id: 'chat-1',
        author_email: 'assistant@legalpal.app',
        user_name_pending: 'Sam Rivera',
        date: '07/28/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p5',
        attachmentName: 'NDA.pdf',
        attachmentUrl: 'https://qix.cloud/mock/nda3.pdf',
        created: Date.now() - 86400000 * 4,
        author_id: 'chat-1',
        author_email: 'sender@legalpal.app',
        user_name_pending: 'Jane Client',
        date: '07/25/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p6',
        attachmentName: 'Retainer Agreement - Draft.pdf',
        attachmentUrl: 'https://qix.cloud/mock/retainer.pdf',
        created: Date.now() - 86400000 * 4 - 5400000,
        author_id: 'chat-1',
        author_email: 'mobile.test@legalpal.app',
        user_name_pending: 'Chris Patel',
        date: '07/25/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p7',
        attachmentName: 'Discovery Request Responses.pdf',
        attachmentUrl: 'https://qix.cloud/mock/discovery.pdf',
        created: Date.now() - 86400000 * 7,
        author_id: 'chat-1',
        author_email: 'mobile.test@legalpal.app',
        user_name_pending: 'Jordan Lee',
        date: '07/22/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p8',
        attachmentName: 'Settlement Release (Client).pdf',
        attachmentUrl: 'https://qix.cloud/mock/release.pdf',
        created: Date.now() - 86400000 * 9,
        author_id: 'chat-1',
        author_email: 'ops@legalpal.app',
        user_name_pending: 'Taylor Brooks',
        date: '07/20/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p9',
        attachmentName: 'HIPAA Authorization.pdf',
        attachmentUrl: 'https://qix.cloud/mock/hipaa.pdf',
        created: Date.now() - 86400000 * 11,
        author_id: 'chat-1',
        author_email: 'mobile.test@legalpal.app',
        user_name_pending: 'Jane Client',
        date: '07/18/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p10',
        attachmentName: 'Engagement Letter.pdf',
        attachmentUrl: 'https://qix.cloud/mock/engage.pdf',
        created: Date.now() - 86400000 * 14,
        author_id: 'chat-1',
        author_email: 'sender@legalpal.app',
        user_name_pending: 'Morgan Quinn',
        date: '07/15/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p11',
        attachmentName: 'Conflict Waiver.pdf',
        attachmentUrl: 'https://qix.cloud/mock/conflict.pdf',
        created: Date.now() - 86400000 * 18,
        author_id: 'chat-1',
        author_email: 'mobile.test@legalpal.app',
        user_name_pending: 'Riley Chen',
        date: '07/11/2026',
        chatId: 'chat-1',
      },
      {
        id: 'p12',
        attachmentName: 'Intake Questionnaire - Personal Injury.pdf',
        attachmentUrl: 'https://qix.cloud/mock/intake-q.pdf',
        created: Date.now() - 86400000 * 21,
        author_id: 'chat-1',
        author_email: 'assistant@legalpal.app',
        user_name_pending: 'Casey Nguyen',
        date: '07/08/2026',
        chatId: 'chat-1',
      },
    ];
    completedSignature = [
      {
        id: 'c1',
        attachmentName: 'Response_to_form_interrogatories.pdf',
        attachmentUrl: 'https://qix.cloud/mock/signed.pdf',
        date: '07/30/2026',
        author_email: 'erikhyndman@gmail.com',
        signedPdf: [],
        meta: [{ author: 'Richard (Rick) Herron' }],
      },
      {
        id: 'c2',
        attachmentName: 'IMR APPEAL-FREEMAN.pdf',
        attachmentUrl: 'https://qix.cloud/mock/interrogs.pdf',
        date: '07/29/2026',
        author_email: 'erikhyndman@gmail.com',
        signedPdf: [],
        meta: [{ author: 'Erik Hyndman' }],
      },
      {
        id: 'c3',
        attachmentName: 'IMR APPEAL-LUPIAN - Very Long Completed Document Name.pdf',
        attachmentUrl: 'https://qix.cloud/mock/ack.pdf',
        date: '07/28/2026',
        author_email: 'alex.morgan@example.com',
        signedPdf: [],
        meta: [{ author: 'Alex Morgan Longname' }],
      },
      {
        id: 'c4',
        attachmentName: 'Power of Attorney.pdf',
        attachmentUrl: 'https://qix.cloud/mock/poa.pdf',
        date: '2026-07-18',
        author_email: 'sam.rivera@example.com',
        signedPdf: [],
        meta: [{ author: 'Sam Rivera' }],
      },
      {
        id: 'c5',
        attachmentName: 'Settlement Agreement - Final.pdf',
        attachmentUrl: 'https://qix.cloud/mock/settle.pdf',
        date: '2026-07-12',
        author_email: 'jordan.lee@example.com',
        signedPdf: [],
        meta: [{ author: 'Jordan Lee' }],
      },
      {
        id: 'c6',
        attachmentName: 'Declaration of Client.pdf',
        attachmentUrl: 'https://qix.cloud/mock/decl.pdf',
        date: '2026-07-05',
        author_email: 'taylor.brooks@example.com',
        signedPdf: [],
        meta: [{ author: 'Taylor Brooks' }],
      },
      {
        id: 'c7',
        attachmentName: 'Verification of Employment.pdf',
        attachmentUrl: 'https://qix.cloud/mock/voe.pdf',
        date: '2026-06-28',
        author_email: 'casey.nguyen@example.com',
        signedPdf: [],
        meta: [{ author: 'Casey Nguyen' }],
      },
      {
        id: 'c8',
        attachmentName: 'Consent to Representation.pdf',
        attachmentUrl: 'https://qix.cloud/mock/consent-rep.pdf',
        date: '2026-06-20',
        author_email: 'riley.chen@example.com',
        signedPdf: [],
        meta: [{ author: 'Riley Chen' }],
      },
    ];
    templates = [
      {
        id: 't1',
        pdfName: 'Intake Template',
        pdfUrl: 'https://qix.cloud/mock/intake.pdf',
        thumbnail: '/img/default_image.svg',
        loaded: false,
        author_id: 'user-1',
        allObjects: '[[]]',
      },
      {
        id: 't2',
        pdfName: 'CLIENT-Forwarding_Consent_Forms_for_MSA_SSDI_-_Settlement.pdf',
        pdfUrl: 'https://qix.cloud/mock/consent.pdf',
        thumbnail: '/img/default_image.svg',
        loaded: false,
        author_id: 'user-1',
        allObjects: '[[]]',
      },
      {
        id: 't3',
        pdfName: 'Fee Disclosure Statement',
        pdfUrl: 'https://qix.cloud/mock/fee.pdf',
        thumbnail: '/img/default_image.svg',
        loaded: false,
        author_id: 'user-1',
        allObjects: '[[]]',
      },
      {
        id: 't4',
        pdfName: 'HIPAA Authorization - Medical Records Release.pdf',
        pdfUrl: 'https://qix.cloud/mock/hipaa.pdf',
        thumbnail: '/img/default_image.svg',
        loaded: false,
        author_id: 'user-1',
        allObjects: '[[]]',
      },
    ];
    editTemplatesAvailable = true;
    friends = [
      {
        id: 'user-1',
        email: 'mahmoud.naoum.longemail@legalpal.app',
        loggedIn: Date.now() - 3600000,
        settings: {},
      },
      {
        id: 'friend-2',
        email: 'teammate.very.long.email@legalpal.app',
        loggedIn: Date.now() - 86400000,
        settings: {},
      },
      {
        id: 'friend-3',
        email: 'associate.paralegal@ratcliff-conway-llp.example.com',
        loggedIn: Date.now() - 86400000 * 3,
        settings: {},
      },
    ];
    completedArchived = [
      {
        id: 'a1',
        pdfName:
          'Archived_Settlement_Release_Client_Very_Long_Document_Name_Final.pdf',
        date: '04/12/2026',
        attachmentUrl: 'https://qix.cloud/mock/archived1.pdf',
      },
      {
        id: 'a2',
        pdfName: 'Old Engagement Letter.pdf',
        date: '03/01/2026',
        attachmentUrl: 'https://qix.cloud/mock/archived2.pdf',
      },
    ];
    signatureTabLoading = false;
    firstLoading = true;
  }

  let entry_requireds = [];
  let entry_required_txts = [];
  let entry_options = [];
  let entry_option_txts = [];
  let processingSaveTemplate = false;
  let completedSaveTemplate = false;
  let loadingTemplate = false;
  let packetMenu = false;
  let addTextMenu = false;
  let multiplePdfs = [];
  let showArchive = false;
  let showAddPagesMenu = false;
  let merusCaseEnabled = false;
  let fileVineEnabled = false;
  let fluentCaseEnabled = false;
  let twilioEnabled = false;
  let microsoftSharepointTenantId = "";
  let activeTab;
  let previewMode = false;
  let contactPostId = null;
  let signedContactId = null;
  /** Original signed PDF blobs for signedContact preview download (all docs) */
  let signedContactBlobs = [];
  enum Tab {
    Pending = 'messaging',
    Completed = 'completed',
    Templates = 'auto',
    Integration = 'integration',
    Team = 'team'
  }
  // Subscribe to storeUser changes
  storeUser.subscribe((val) => {
    if (val != null) {
      user = val;
      get_company_logo();
    }
  });

    const tutorials = [
    { title: "Sign a Document", id: 0 },
    { title: "Sign a New Document", id: 1 },
    { title: "Create a Template", id: 2 },
    { title: "Create a Packet", id: 3 },
    { title: merusCaseEnabled ? "Automate a Template (Meruscase)" : fluentCaseEnabled ? "Automate a Template (FluentCase)" : "Automate a Template", id: 4 },
    { title: "Automate a Template for Sharepoint", id: 5 },
    { title: "Add Team Members", id: 6 },
    { title: "Load Archived Documents", id: 7 },
    { title: "Change the Signature Color to Blue", id: 8 },
    { title: "Add Custom fields to Signature Web form prompt", id: 9 }
  ];

  function updateAutomationTitle() {
    const tutorial = tutorials.find(t => t.id === 4);
    if (merusCaseEnabled) {
      tutorial.title = "Automate a Template (Meruscase)";
    } else if (fluentCaseEnabled) {
      tutorial.title = "Automate a Template (FluentCase)";
    } else {
      tutorial.title = "Automate a Template";
    }
  }

  if(user.id == "" && !mockMode) {
  console.log('Initial user');
  auth()
    .then((info) => {
      if (info) {
        user = info;
        get_company_logo();
      }
      Promise.all([]).finally(async () => {
              if (user.id != "") {
              let body = {
                auth: "google",
                user_id: user.id,
                app_id: user.appId,
                email: user.email,
                blog_id: blog.blog_id,
                team: friends,
              };
              const req = await fetch(
                blog.siteurl +
                  "/wp-admin/admin-ajax.php?action=getSignatureListForCloudflare",
                {
                  method: "POST",
                  body: JSON.stringify(body),
                }
              );
              let data = null;
              try { data = await req.json(); } catch(e) {}
              pendingSignature = data?.pending || [];
              showArchive = false;
              completedSignature = data.completed;
              templates = data.templates;
              signatureTabLoading = false;
              
              const merusCaseSettings = await fetch(
                "https://api.qix.cloud/" +
                  "settings/" +
                  "merusCase" +
                  "?userId=" +
                  user.appId,
                {
                  method: "GET",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                }
              );
              const fileVineSettings = await fetch(
                "https://api.qix.cloud/" +
                  "settings/" +
                  "fileVine" +
                  "?userId=" +
                  user.appId,
                {
                  method: "GET",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                }
              );

              const fluentCaseSettings = await fetch(
                "https://api.qix.cloud/" +
                  "settings/" +
                  "fluentCase" +
                  "?userId=" +
                  user.appId,
                {
                  method: "GET",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                }
              );

              const twilioSettings = await fetch(
                "https://api.qix.cloud/" +
                  "settings/" +
                  "twilio" +
                  "?userId=" +
                  user.appId,
                {
                  method: "GET",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                }
              );

              const microsoftTenantSettings = await fetch(
                "https://api.qix.cloud/" +
                  "getMicrosoftTenantId",
                {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                  },
                }
              );

              let merusCaseSettingsData = await merusCaseSettings.json();
              let fileVineSettingsData = await fileVineSettings.json();
              let fluentCaseSettingsData = await fluentCaseSettings.json();
              let twilioSettingsData = await twilioSettings.json();
              let microsoftTenantSettingsData = await microsoftTenantSettings.json();

              user.merusCaseEnabled = merusCaseSettingsData.enabled;
              user.fileVineEnabled = fileVineSettingsData.enabled;
              user.fluentCaseEnabled = fluentCaseSettingsData.enabled;
              merusCaseEnabled = merusCaseSettingsData.enabled;
              fileVineEnabled = fileVineSettingsData.enabled;
              fluentCaseEnabled = fluentCaseSettingsData.enabled;
              fluentCaseToken = fluentCaseSettingsData.token;
              twilioEnabled = twilioSettingsData.enabled;
              microsoftSharepointTenantId = microsoftTenantSettingsData.microsoftTenantId;
              updateAutomationTitle
              console.log('user',user,merusCaseEnabled,fileVineEnabled,fluentCaseEnabled);

            }
          });
    })
    .catch(() => {
      firstLoading = false;
    });

  }

  if (!mockMode) {
    refreshTeam();
  }

    onMount(async () => {
    try {
      if (!mockMode && user.id == "") {
        try {
          const authUser = await auth();
          if (authUser) {
            user = authUser;
            get_company_logo();
          }
        } catch (e) {
          console.warn("Sign onMount auth error:", e);
        }
      }
      if (mockMode) {
        firstLoading = true;
        signatureTabLoading = false;
        merusCaseEnabled = true;
        fluentCaseEnabled = true;
        twilioEnabled = true;
        merusToken = 'mock-merus-token';
        fluentCaseToken = 'mock-fluent-token';
        try {
          const params = new URLSearchParams(window.location.search);
          if (params.get('mockShare') === '1') {
            sharePanel = true;
          }
          if (params.get('mockProfile') === '1') {
            newProfilePanel = true;
          }
          if (
            params.get('mockPdf') === '1' ||
            params.get('mockEmail') === '1' ||
            params.get('mockSms') === '1' ||
            params.get('mockSignatureMenu') === '1'
          ) {
            loadingTemplate = true;
            try {
              const res = await fetch('/test.pdf');
              const blob = await res.blob();
              const file = new File([blob], 'Fee Disclosure Statement - Client Intake.pdf', {
                type: 'application/pdf',
              });
              await addPDF(file);
              selectedPageIndex = 0;
              pdfName = 'Fee Disclosure Statement - Client Intake.pdf';
            } catch (pdfErr) {
              console.error('mockPdf load failed', pdfErr);
            } finally {
              loadingTemplate = false;
            }
          }
          if (params.get('mockEmail') === '1') {
            merusCaseEnabled = true;
            fluentCaseEnabled = true;
            sharePanel = false;
            usersPanel = true;
            sendPDFType = 'email';
            emailPanel = true;
            emailSubject = 'Fee Disclosure Statement / Please review and sign';
          }
          if (params.get('mockSms') === '1') {
            merusCaseEnabled = true;
            twilioEnabled = true;
            sharePanel = false;
            usersPanel = true;
            sendPDFType = 'sms';
            emailPanel = true;
          }
          if (params.get('mockSignatureMenu') === '1') {
            quickSigns = [{ name: 'Erik', image: '/img/default_image.svg' }];
            signatureMenu = true;
          }
        } catch (e) {}
        return;
      }
      if (typeof window !== 'undefined') {
        try {
          const liveParams = readPreviewQueryParams();
          contactPostId =
            liveParams.contactPost ||
            bootPreviewParams.contactPost ||
            sessionStorage.getItem('signPreview_contactPost');
          signedContactId =
            liveParams.signedContact ||
            bootPreviewParams.signedContact ||
            sessionStorage.getItem('signPreview_signedContact');
          console.log('Sign URL params', {
            href: window.location.href,
            search: window.location.search,
            contactPostId,
            signedContactId,
            bootPreviewParams,
          });
        } catch (error) {
          console.error('Error parsing URL parameters:', error);
        }
      }
      if (signedContactId) {
        try {
          previewMode = true;
          // Same timing pattern as contactPost preview
          setTimeout(async () => {
            try {
              console.log('signedContact preview start', signedContactId);
              await loadSignedContactPreview(signedContactId);
              console.log('signedContact preview loaded', pages.length, 'pages');
              const absoluteElements = document.querySelectorAll('.absolute');
              setTimeout(() => {
                absoluteElements.forEach((element) => {
                  element.style.pointerEvents = 'none';
                  if (element.classList.contains('delete-sign')) {
                    element.style.display = 'none';
                  }
                });
              }, 500);
            } catch (e) {
              console.error('Invalid signed contact data', e);
              alert('Could not load signed documents. Please try again.');
            }
          }, 500);
          firstLoading = false;
        } catch (e) {
          console.error('Invalid signed contact data', e);
        }
      } else if (contactPostId) {
        try {
          previewMode = true;
          
          const pendingContactPosts = await getContactPost(contactPostId);
          const template = convertPendingToTemplate(pendingContactPosts[0]);
          
          console.log('pendingtoTemplateStr',template);
          setTimeout(async () => {
            await loadTemplate(template);
            for (let i = 1; i < pendingContactPosts.length; i++) {
              await loadExtraTemplate(convertPendingToTemplate(pendingContactPosts[i]));
            }
            const absoluteElements = document.querySelectorAll('.absolute');
            setTimeout(() => {
              absoluteElements.forEach(element => {
                element.style.pointerEvents = 'none';
                if (element.classList.contains('delete-sign')) {
                  element.style.display = 'none';
                }
              });
            }, 500); 
          }, 500); 
          firstLoading = false;
        } catch (e) {
          console.error('Invalid template data', e);
        }
      }

      firstLoading = false;
      await getDefaultDoc();
      await checkCustomerSubscriptionStatus();
      firstLoading = true;
      setTimeout( async () => {
        fetchFont(currentFont);
        prepareAssets();
        getMerusToken();
        getEmailNotifyAvailable();
        getTeamViewCompletedDocAvailable();
        getShareSettingsAvailable();
        editTemplatesAvailableFunc();
        getEmailSettings();
        // getFluentCaseToken();
        try {
          const chats = await getChatUsers();
          chatUsers = Array.isArray(chats) ? chats : [];
        } catch (e) {
          chatUsers = [];
        }
      }, 3000);
    } catch (e) {
      console.log(e);
      if (mockMode) firstLoading = true;
    }
  });

  $: if (tutorialStep !== undefined) {
    displayTutorial(tutorialStep, tutorialNumber);
  }

  function onBack() {
    window.open(buildSignUrl(contactPostId || signedContactId), '_blank');
  }

  function onSignDocument() {
    window.open(buildSignUrl(contactPostId || signedContactId), '_blank');
  }
  function convertPendingToTemplate(pending) {
    return {
      id: pending.id,
      author_id: pending.author_id,
      pdfName: pending.attachmentName,
      pdfUrl: pending.attachmentUrl,
      PdfPath: pending.attachmentUrl.replace('https://qix.cloud', '/var/www/html'), // assuming path transformation
      allObjects: pending.allObjects,
      created: pending.created
    };
  }

  async function checkCustomerSubscriptionStatus() {
    if (user.id == "" || user.subscribed) return;
    let body = new URLSearchParams();
    body.append("action", "checkCustomerSubscriptionStatus");
    body.append("email", user.email);
    const req = await fetch(blog.siteurl + "/ajax/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    });
    let res = await req.json();
    user.subscribed = res.status;
  }
  async function get_company_logo() {
    let body = { appId: user.appId, email: user.email };
    const req = await fetch(blog.siteurl + "/ajax/logo.php", {
      method: "POST",
      body: JSON.stringify(body),
    });
    let res = await req.json();
    logo = res.logo.replace("{{api}}", "https://api.qix.cloud/");
  }
  const copy = () => {
    const app = new CopyClipBoard({
      target: document.getElementById("clipboard"),
      props: { clipboardTxt },
    });

    app.$destroy();
    //clipboardTxt = "";
    //usersPanel = false;
    alert("Copied.");
  };
  const copyInviteUrl = () => {
    clipboardTxt = inviteClipboardTxt;
    const app = new CopyClipBoard({
      target: document.getElementById("inviteclipboard"),
      props: { clipboardTxt },
    });

    app.$destroy();
    //clipboardTxt = "";
    //usersPanel = false;
    alert("Copied.");
  };
  const copySignUrl = () => {
    clipboardTxt = signUrl;
    const app = new CopyClipBoard({
      target: document.getElementById("signclipboard"),
      props: { clipboardTxt },
    });

    app.$destroy();
    //clipboardTxt = "";
    //usersPanel = false;
    alert("Copied.");
  };
  async function onUploadPDF(e) {
    const files = e.target.files || (e.dataTransfer && e.dataTransfer.files);
    const file = files[0];
    if (!file) return;

    // Check file type - only PDFs are allowed
    if (file.type !== "application/pdf") {
      const fileName = file.name.toLowerCase();
      if (fileName.endsWith(".doc") || fileName.endsWith(".docx")) {
        alert("Word documents (.doc, .docx) are not supported. Please upload a PDF file.");
      } else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png")) {
        alert("Image files are not supported. Please upload a PDF file.");
      } else {
        alert("Only PDF files are allowed. Please upload a PDF file.");
      }
      return;
    }

    loadingTemplate = true;
    selectedPageIndex = -1;
    try {
      await addPDF(file);
      selectedPageIndex = 0;
      setTimeout(function () {
        window.scrollTo({ top: 0, behavior: "auto" });
        loadingTemplate = false;
      }, 1000);
    } catch (e) {
      console.log(e);
      loadingTemplate = false;
    }
  }
  async function addPDF(file) {
    try {
      if (!mockMode) getSignatures();
      const pdf = await readAsPDF(file);
      pdfName = file.name;
      pdfFile = file;
      const numPages = pdf.numPages;
      pages = Array(numPages)
        .fill()
        .map((_, i) => pdf.getPage(i + 1));
      allObjects = pages.map(() => []);
      pagesScale = Array(numPages).fill(1);
    } catch (e) {
      console.log("Failed to add pdf.");
      throw e;
    }
  }
  async function onUploadImage(e) {
    const file = e.target.files[0];
    if (file && selectedPageIndex >= 0) {
      addImage(file);
    }
    e.target.value = null;
  }
  async function addImage(file) {
    try {
      // get dataURL to prevent canvas from tainted
      const url = await readAsDataURL(file);
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      const object = {
        id,
        type: "image",
        width,
        height,
        x: 0,
        y: 0,
        payload: img,
        file,
      };
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }
  function onAddTextField() {
    if (selectedPageIndex >= 0) {
      addTextField();
    }
  }
  function addTextField(text = "New Text Field", pos = false) {
    addTextMenu = false;
    const id = genID();
    fetchFont(currentFont);
    const object = {
      id,
      text,
      type: "text",
      size: 12,
      width: 0, // recalculate after editing
      lineHeight: 1.4,
      fontFamily: currentFont,
      x: 0,
      y: 0,
    };
    if (pos) {
      object.x = layerPos.x;
      object.y = layerPos.y;
    }
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex === selectedPageIndex ? [...objects, object] : objects
    );
  }
  function onAddDrawing() {
    if (selectedPageIndex >= 0) {
      addingDrawing = true;
      signatureMenu = false;
    }
  }
  function addDrawing(originWidth, originHeight, path, scale = 1) {
    const id = genID();
    const object = {
      id,
      path,
      type: "drawing",
      x: 0,
      y: 0,
      originWidth,
      originHeight,
      width: originWidth * scale,
      scale,
    };
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex === selectedPageIndex ? [...objects, object] : objects
    );
  }
  function selectFontFamily(event) {
    const name = event.detail.name;
    fetchFont(name);
    currentFont = name;
  }
  function selectPage(index) {
    selectedPageIndex = index;
  }
  function handleAddPagesAbove(e) {
    const file = e.target.files?.[0];
    if (file) {
      addPagesAbove(file);
      e.target.value = ''; // Reset input
    }
  }
  function handleAddPagesBelow(e) {
    const file = e.target.files?.[0];
    if (file) {
      addPagesBelow(file);
      e.target.value = ''; // Reset input
    }
  }
  function updateObject(objectId, payload) {
    if (payload.text == "New Text Field") {
      payload.text = payload.lines[0];
    } else if (payload.text == "Phone_Number") {
      payload.text = "Phone_" + payload.lines[0].replace("Phone_", "").trim();
    } else if (payload.text == "Entry Required") {
      payload.text =
        "entry_r_" +
        payload.lines[0]
          .replace("Entry Required", "")
          .trim()
          .replace(/\s+/g, " ")
          .replace(/ /g, "_");
      if (
        !entry_required_txts.includes(payload.text) &&
        payload.text != "entry_r_"
      ) {
        entry_required_txts.push(payload.text);
        entry_requireds.push(payload);
      }
    } else if (payload.text == "Entry Optional") {
      payload.text =
        "entry_o_" +
        payload.lines[0]
          .replace("Entry Optional", "")
          .trim()
          .replace(/\s+/g, " ")
          .replace(/ /g, "_");
      if (
        !entry_option_txts.includes(payload.text) &&
        payload.text != "entry_o_"
      ) {
        entry_option_txts.push(payload.text);
        entry_options.push(payload);
      }
    }
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex == selectedPageIndex
        ? objects.map((object) =>
            object.id === objectId ? { ...object, ...payload } : object
          )
        : objects
    );
  }
  function deleteObject(objectId) {
    allObjects = allObjects.map((objects, pIndex) =>
      pIndex == selectedPageIndex
        ? objects.filter((object) => object.id !== objectId)
        : objects
    );
  }
  // Delete selected page
  function deletePage() {
    if (selectedPageIndex < 0 || pages.length <= 1) return;
    pages = pages.filter((_, i) => i !== selectedPageIndex);
    allObjects = allObjects.filter((_, i) => i !== selectedPageIndex);
    pagesScale = pagesScale.filter((_, i) => i !== selectedPageIndex);
    
    // Update multiplePdfs pages count
    if (multiplePdfs.length > 0) {
      let currentPageCount = 0;
      for (let i = 0; i < multiplePdfs.length; i++) {
        const prevCount = currentPageCount;
        currentPageCount = multiplePdfs[i].pages;
        if (prevCount <= selectedPageIndex && selectedPageIndex < currentPageCount) {
          multiplePdfs[i].pages--;
          // Adjust subsequent PDFs
          for (let j = i + 1; j < multiplePdfs.length; j++) {
            multiplePdfs[j].pages--;
          }
          break;
        }
      }
    }
    
    // Adjust selectedPageIndex
    if (selectedPageIndex >= pages.length) {
      selectedPageIndex = pages.length - 1;
    }
  }
  // Add pages above selected page
  async function addPagesAbove(file) {
    if (!file || file.type !== "application/pdf" || selectedPageIndex < 0) return;
    try {
      const pdf = await readAsPDF(file);
      const numPages = pdf.numPages;
      
      // Merge pages into existing PDF - just insert pages into arrays
      // Insert pages before selectedPageIndex
      pages = [
        ...pages.slice(0, selectedPageIndex),
        ...Array.from({ length: numPages }, (_, i) => pdf.getPage(i + 1)),
        ...pages.slice(selectedPageIndex)
      ];
      
      // Initialize allObjects for new pages
      allObjects = [
        ...allObjects.slice(0, selectedPageIndex),
        ...Array(numPages).fill(null).map(() => []),
        ...allObjects.slice(selectedPageIndex)
      ];
      
      // Initialize pagesScale for new pages
      pagesScale = [
        ...pagesScale.slice(0, selectedPageIndex),
        ...Array(numPages).fill(1),
        ...pagesScale.slice(selectedPageIndex)
      ];
      
      // Update multiplePdfs page counts for all PDFs that come after the insertion point
      let currentPageCount = 0;
      for (let i = 0; i < multiplePdfs.length; i++) {
        currentPageCount = multiplePdfs[i].pages;
        if (selectedPageIndex < currentPageCount) {
          // This PDF and all subsequent PDFs need their page count adjusted
          for (let j = i; j < multiplePdfs.length; j++) {
            multiplePdfs[j].pages += numPages;
          }
          break;
        }
      }
    } catch (e) {
      console.log("Failed to add pages above.", e);
    }
  }
  // Add pages below selected page
  async function addPagesBelow(file) {
    if (!file || file.type !== "application/pdf" || selectedPageIndex < 0) return;
    try {
      const pdf = await readAsPDF(file);
      const numPages = pdf.numPages;
      const insertIndex = selectedPageIndex + 1;
      
      // Merge pages into existing PDF - just insert pages into arrays
      // Insert pages after selectedPageIndex
      pages = [
        ...pages.slice(0, insertIndex),
        ...Array.from({ length: numPages }, (_, i) => pdf.getPage(i + 1)),
        ...pages.slice(insertIndex)
      ];
      
      // Initialize allObjects for new pages
      allObjects = [
        ...allObjects.slice(0, insertIndex),
        ...Array(numPages).fill(null).map(() => []),
        ...allObjects.slice(insertIndex)
      ];
      
      // Initialize pagesScale for new pages
      pagesScale = [
        ...pagesScale.slice(0, insertIndex),
        ...Array(numPages).fill(1),
        ...pagesScale.slice(insertIndex)
      ];
      
      // Update multiplePdfs page counts for all PDFs that come after the insertion point
      let currentPageCount = 0;
      for (let i = 0; i < multiplePdfs.length; i++) {
        currentPageCount = multiplePdfs[i].pages;
        if (insertIndex <= currentPageCount) {
          // This PDF and all subsequent PDFs need their page count adjusted
          for (let j = i; j < multiplePdfs.length; j++) {
            multiplePdfs[j].pages += numPages;
          }
          break;
        }
      }
    } catch (e) {
      console.log("Failed to add pages below.", e);
    }
  }
  // Splice page - save selected page as separate PDF
  async function splicePage() {
    if (selectedPageIndex < 0 || !pages[selectedPageIndex]) return;
    try {
      const { getAsset } = await import('../../utils/prepareAssets.js');
      const PDFLib = await getAsset("PDFLib");
      const download = await getAsset("download");
      const { readAsPDF, readAsArrayBuffer } = await import('../../utils/asyncReader.js');
      
      // Get the page and its objects - ensure page is resolved if it's a promise
      let page = pages[selectedPageIndex];
      if (page && typeof page.then === 'function') {
        page = await page;
      }
      const pageObjects = allObjects[selectedPageIndex] || [];
      
      // Get the original PDF file if available
      let sourceBlob = pdfFile;
      let sourcePageIndex = selectedPageIndex;
      
      // Convert pdfFile to Blob if needed
      if (sourceBlob && !(sourceBlob instanceof Blob)) {
        sourceBlob = new Blob([sourceBlob], { type: 'application/pdf' });
      }
      
      if (!sourceBlob && pdfFiles.length > 0) {
        // Find the PDF file that contains this page
        let pageCount = 0;
        for (let [fileBlob] of pdfFiles) {
          try {
            const testPdf = await readAsPDF(fileBlob);
            if (selectedPageIndex >= pageCount && selectedPageIndex < pageCount + testPdf.numPages) {
              sourceBlob = fileBlob;
              sourcePageIndex = selectedPageIndex - pageCount;
              break;
            }
            pageCount += testPdf.numPages;
          } catch (e) {
            console.log("Failed to read PDF for page detection:", e);
          }
        }
      }
      
      if (!sourceBlob) {
        alert("Unable to locate source PDF for this page.");
        return;
      }
      
      // Get page dimensions - ensure page is resolved
      if (!page || typeof page.getViewport !== 'function') {
        // If page is still not a valid page object, get it from the source PDF
        const sourcePdf = await readAsPDF(sourceBlob);
        page = await sourcePdf.getPage(sourcePageIndex + 1);
      }
      const viewport = page.getViewport({ scale: 1 });
      const pageWidth = viewport.width;
      const pageHeight = viewport.height;
      
      // Validate page dimensions
      if (!pageWidth || !pageHeight || isNaN(pageWidth) || isNaN(pageHeight)) {
        throw new Error(`Invalid page dimensions: width=${pageWidth}, height=${pageHeight}`);
      }
      
      // Render the page to canvas with objects (if any are signatures/drawings, they need canvas rendering)
      // For better quality, we'll render at high resolution
      const pdfjsLib = await getAsset('pdfjsLib');
      const SCALE = 3; // High resolution
      const renderViewport = page.getViewport({ scale: SCALE });
      
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      canvas.width = renderViewport.width;
      canvas.height = renderViewport.height;
      
      // Render the base PDF page
      await page.render({
        canvasContext: context,
        viewport: renderViewport
      }).promise;
      
      // Draw all objects on the canvas (signatures, images, text, drawings)
      // This ensures everything is included in the final PDF
      const scaleX = renderViewport.width / pageWidth;
      const scaleY = renderViewport.height / pageHeight;
      
      for (const object of pageObjects) {
        try {
          if (object.type === "Signature" || object.type === "quickSign") {
            // Signatures might be data URLs or file URLs
            const img = document.createElement('img');
            const imgSrc = object.file || object.url || object.payload;
            if (imgSrc) {
              await new Promise<void>((resolve, reject) => {
                img.onload = () => {
                  context.drawImage(
                    img,
                    object.x * scaleX,
                    (pageHeight - object.y - object.height) * scaleY,
                    object.width * scaleX,
                    object.height * scaleY
                  );
                  resolve();
                };
                img.onerror = reject;
                img.src = typeof imgSrc === 'string' ? imgSrc : URL.createObjectURL(imgSrc);
              });
            }
          } else if (object.type === "image") {
            // Draw images on canvas
            const img = document.createElement('img');
            const imgSrc = object.file || object.url;
            if (imgSrc) {
              await new Promise<void>((resolve, reject) => {
                img.onload = () => {
                  context.drawImage(
                    img,
                    object.x * scaleX,
                    (pageHeight - object.y - object.height) * scaleY,
                    object.width * scaleX,
                    object.height * scaleY
                  );
                  resolve();
                };
                img.onerror = reject;
                img.src = typeof imgSrc === 'string' ? imgSrc : URL.createObjectURL(imgSrc);
              });
            }
          } else if (object.type === "text") {
            // Draw text on canvas
            if (
              object.text != "Initial" &&
              object.text != "Date" &&
              object.text != "Name"
            ) {
              const fontSize = (object.size || 12) * scaleY;
              const fontFamily = object.fontFamily || "Arial";
              context.font = `${fontSize}px ${fontFamily}`;
              context.fillStyle = "#000000";
              context.textBaseline = "top";
              
              const lines = object.lines || [object.text];
              const lineHeight = (object.lineHeight || 1.2) * fontSize;
              let yPos = (pageHeight - object.y) * scaleY;
              
              // Draw each line
              for (let i = lines.length - 1; i >= 0; i--) {
                context.fillText(
                  lines[i],
                  object.x * scaleX,
                  yPos - fontSize
                );
                yPos -= lineHeight;
              }
            }
          } else if (object.type === "drawing" || object.type === "drawingSign") {
            // Draw SVG path on canvas (simplified - converts path to canvas strokes)
            if (object.path) {
              context.strokeStyle = "#000000";
              context.lineWidth = 5 * Math.min(scaleX, scaleY);
              context.lineCap = "round";
              context.lineJoin = "round";
              
              // Parse SVG path and draw (simplified version)
              // Note: Full SVG path parsing would be complex, this is a basic implementation
              const path2D = new Path2D(object.path);
              context.translate(object.x * scaleX, (pageHeight - object.y) * scaleY);
              context.scale((object.scale || 1) * scaleX, -(object.scale || 1) * scaleY);
              context.stroke(path2D);
              context.setTransform(1, 0, 0, 1, 0, 0); // Reset transform
            }
          }
        } catch (e) {
          console.log(`Failed to render ${object.type} on canvas:`, e);
        }
      }
      
      // Create new PDF with just this page
      const newPdfDoc = await PDFLib.PDFDocument.create();
      
      // Convert canvas to blob, then to array buffer for embedding
      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Failed to generate canvas blob"));
            return;
          }
          resolve(blob);
        }, 'image/png');
      });
      
      // Convert blob to array buffer
      const imageBytes = await readAsArrayBuffer(blob);
      
      // Embed the PNG image (includes base page + all objects)
      const pngImage = await newPdfDoc.embedPng(imageBytes);
      
      if (!pngImage) {
        throw new Error("Failed to embed PNG image");
      }
      
      // Ensure dimensions are numbers before creating page
      const finalWidth = Number(pageWidth);
      const finalHeight = Number(pageHeight);
      
      if (isNaN(finalWidth) || isNaN(finalHeight) || finalWidth <= 0 || finalHeight <= 0) {
        throw new Error(`Invalid dimensions for new page: width=${finalWidth}, height=${finalHeight}`);
      }
      
      const newPage = newPdfDoc.addPage([finalWidth, finalHeight]);
      newPage.drawImage(pngImage, {
        x: 0,
        y: 0,
        width: finalWidth,
        height: finalHeight,
      });
      
      const pdfBytes = await newPdfDoc.save();
      const fileName = (pdfName || 'document').replace('.pdf', '') + `_page_${selectedPageIndex + 1}.pdf`;
      download(pdfBytes, fileName, "application/pdf");
    } catch (e) {
      console.log("Failed to splice page.", e);
      alert("Failed to save page as PDF. Please try again.");
    }
  }
  function onMeasure(scale, image, i) {
    pagesScale[i] = scale;
    if (i == 0) tempThumb = image;
  }
  // FIXME: Should wait all objects finish their async work
  async function savePDF() {
    if (saving || !pages.length) return;
    // signedContact preview: download ALL signed docs as one merged PDF
    if (signedContactId) {
      saving = true;
      try {
        await downloadAllSignedContactPdfs();
      } catch (e) {
        console.log(e);
        alert("Failed to download signed documents. Please try again.");
      } finally {
        saving = false;
      }
      return;
    }
    if (!pdfFile) return;
    saving = true;
    try {
      console.log("allObjects", allObjects);
      await save(pdfFile, allObjects, pdfName, pagesScale);
    } catch (e) {
      console.log(e);
    } finally {
      saving = false;
    }
  }

  /** Merge every signed PDF from the signedContact preview into one downloadable file */
  async function downloadAllSignedContactPdfs() {
    const blobs = signedContactBlobs.length
      ? signedContactBlobs
      : [
          ...(pdfFile ? [pdfFile] : []),
          ...pdfFiles.map(([fileBlob]) => fileBlob),
        ].filter(Boolean);

    if (!blobs.length) {
      throw new Error("No signed PDFs available to download");
    }

    const { getAsset } = await import("../../utils/prepareAssets.js");
    const PDFLib = await getAsset("PDFLib");
    const download = await getAsset("download");

    if (blobs.length === 1) {
      const only = blobs[0];
      const bytes =
        only instanceof Blob
          ? new Uint8Array(await only.arrayBuffer())
          : only instanceof ArrayBuffer
            ? new Uint8Array(only)
            : only;
      const name = (pdfName || `signed_${signedContactId}`).replace(/\.pdf$/i, "") + ".pdf";
      download(bytes, name, "application/pdf");
      return;
    }

    const mergedPdf = await PDFLib.PDFDocument.create();
    for (let i = 0; i < blobs.length; i++) {
      const blob = blobs[i];
      const bytes =
        blob instanceof Blob
          ? await blob.arrayBuffer()
          : blob instanceof ArrayBuffer
            ? blob
            : blob;
      try {
        const src = await PDFLib.PDFDocument.load(bytes, {
          ignoreEncryption: true,
          updateMetadata: false,
        });
        const copied = await mergedPdf.copyPages(src, src.getPageIndices());
        copied.forEach((page) => mergedPdf.addPage(page));
      } catch (err) {
        console.error(`Failed to merge signed PDF ${i + 1}:`, err);
      }
    }

    if (mergedPdf.getPageCount() === 0) {
      throw new Error("Merged PDF has no pages");
    }

    const outBytes = await mergedPdf.save({
      useObjectStreams: false,
      addDefaultPage: false,
      updateFieldAppearances: false,
    });
    const name =
      (pdfName || `signed_${signedContactId}`).replace(/\.pdf$/i, "") +
      "-all.pdf";
    download(outBytes, name, "application/pdf");
  }
  async function sendPDFfunc(type) {
    sendPDFType = type;
    sendPDFRes = false;
    display_name_panel = false;
    hideNewUserPanel();
    sendPDF();
  }
  async function sendPDF() {
    sharePanel = false;
    uploadedToFluentCase = false;
    uploadToFluentCase = false;
    if (sendPDFType == "fluentCase") {
      usersPanel = true;
      uploadToFluentCase = true;
    } else if (sendPDFType == "link") {
      sendSignature(0);
    } else if (user.id != "") {
      if(sendPDFType == "sms") {
        emailSubject = "";
      } else {
        await getEmailSettings(); 
      }
      usersPanel = true;
    } else {
      loginError = "";
      loginOnly = false;
      loginPanel = true;
      return;
    }
  }

  function showLoginPopup() {
    loginOnly = true;
    loginError = "";
    loginPanel = true;
  }
  async function handleUserSelect(event) {
    selectedUser = event.detail.item;
    smsSelectedUser = event.detail.item;
    console.log("selectedUser", selectedUser);
    console.log("selectedUser sendPDFType", selectedUser.tw_b_id < 2);

    smsLang = smsLang == "" ? selectedUser.lang : smsLang;

  }
  async function handleChatUserSelect(event) {
    shareEmail = event.detail.item.email;
    selectedChatUser = event.detail.item;
    if (event.detail.item.id != "") {
      shareUserId = event.detail.item.id;
      shareUserName = event.detail.item.fullName;
      shareCaseFileId = event.detail.item.advanced.caseFileIds.toString();
      // const matter = event.detail.item.tags.find(tag => tag.name === "matterId");
      // matterId = matter ? matter.id : "";
      if (event.detail.item.fluentCaseMattersIds && event.detail.item.fluentCaseMattersIds.length > 0) {
        matterId = event.detail.item.fluentCaseMattersIds[0].toString();
        console.log("handleChatUserSelect", matterId);
      }else {
        console.log("handleChatUserSelect", "false");
      }
    }
    checkIfEmailFunc();
  }
  async function handleChatUserEnterEmail(event) {
    shareEmail = event.detail.item.email;
    shareUserId = "";
    shareUserName = "";
    shareCaseFileId = "";
    // const matter = event.detail.tags.find(tag => tag.name === "matterId");
    // matterId = matter ? matter.id : "";
    if (event.detail.item.fluentCaseMattersIds && event.detail.item.fluentCaseMattersIds.length > 0) {
        matterId = event.detail.item.fluentCaseMattersIds[0].toString();
        console.log("handleChatUserEnterEmail", matterId);
    }else {
      console.log("handleChatUserEnterEmail", "false");
    }
    checkIfEmailFunc();
  }

  function handleItemAdded(event) {
    const newItem = event.detail.item;
    // Add the new item to chatUsers if it doesn't already exist
    const existingIndex = chatUsers.findIndex(u => u.id === newItem.id);
    if (existingIndex === -1) {
      chatUsers = [...chatUsers, newItem];
    } else {
      // Update existing item
      chatUsers = chatUsers.map(u => u.id === newItem.id ? newItem : u);
    }
  }

  function handleItemUpdated(event) {
    const updated = event.detail?.item;
    if (!updated?.id) return;
    const existingIndex = chatUsers.findIndex((u) => u.id === updated.id);
    if (existingIndex === -1) {
      chatUsers = [...chatUsers, updated];
      return;
    }
    chatUsers = chatUsers.map((u) =>
      u.id === updated.id ? { ...u, ...updated, assignedTo: updated.assignedTo ?? u.assignedTo } : u
    );
    if (selectedChatUser?.id === updated.id) {
      selectedChatUser = {
        ...selectedChatUser,
        ...updated,
        assignedTo: updated.assignedTo ?? selectedChatUser.assignedTo,
      };
    }
  }

  async function updateEmailSettings() {
    let body = { user_id: user.id, sentEmailSubject: emailSubject, cc: emailCC, save: true };
    const req = await fetch(
      blog.siteurl + "/ajax/emailSettings.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
  }

  function syncShareUserFromChat(chatUser) {
    if (!chatUser) return;
    if (chatUser.id != null && chatUser.id !== "") {
      shareUserId = chatUser.id;
    }
    if (chatUser.fullName) {
      shareUserName = chatUser.fullName;
    }
  }

  async function handleSendSMS(event) {
    const modifiedUser = event.detail.modifiedUser;
    if (modifiedUser) {
      // Update the selectedChatUser with the modified one (which has selected IDs only)
      selectedChatUser = modifiedUser;
      // Set the caseFileId and matterId from the modified user
      if (modifiedUser.advanced && modifiedUser.advanced.caseFileIds && modifiedUser.advanced.caseFileIds.length > 0) {
        shareCaseFileId = modifiedUser.advanced.caseFileIds[0];
      }
      if (modifiedUser.fluentCaseMattersIds && modifiedUser.fluentCaseMattersIds.length > 0) {
        matterId = modifiedUser.fluentCaseMattersIds[0];
      }
    }
    syncShareUserFromChat(modifiedUser || selectedChatUser);
    await sendSignature(0, 1, 1, "", "", emailCC);
    let res = await fetch("https://api.qix.cloud/message", {
      headers: {
        accept: "*/*",
        "accept-language": "en-US,en;q=0.9,ar;q=0.8",
        authorization:
          "Bearer " + localStorage.getItem("token"),
        "content-type": "application/json",
        "sec-ch-ua": '"Chromium";v="136", "Microsoft Edge";v="136", "Not.A/Brand";v="99"',
        "sec-ch-ua-mobile": "?0",
        "sec-ch-ua-platform": '"Windows"',
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "cross-site",
        Referer: "https://qixcloud-chat.pages.dev/",
        "Referrer-Policy": "strict-origin-when-cross-origin",
      },
      body: JSON.stringify({
        chat: selectedChatUser.id,
        message: emailSubject + "\n" + clipboardTxt,
        twilio: user.appId,
        sendToFileVine: false,
      }),
      method: "POST",
    });
    selectedUser = "";
  }

  async function handleSendEmail(event) {
    const modifiedUser = event.detail.modifiedUser;
    if (modifiedUser) {
      // Update the selectedChatUser with the modified one (which has selected IDs only)
      selectedChatUser = modifiedUser;
      // Set the caseFileId and matterId from the modified user
      if (modifiedUser.advanced && modifiedUser.advanced.caseFileIds && modifiedUser.advanced.caseFileIds.length > 0) {
        shareCaseFileId = modifiedUser.advanced.caseFileIds[0];
      }
      if (modifiedUser.fluentCaseMattersIds && modifiedUser.fluentCaseMattersIds.length > 0) {
        matterId = modifiedUser.fluentCaseMattersIds[0];
      }
      syncShareUserFromChat(modifiedUser);
    }
    smsLang = smsLang == "" ? selectedUser.lang : smsLang;
    updateEmailSettings();
    sendSignature(0, 1, 1, "", shareEmail, emailCC);
    selectedUser = "";
  }
  async function handleLanguageSelect() {}
  async function sendSignature(
    contact_id = 0,
    cblog = "",
    tw_b_id = 0,
    phone = "",
    email = "",
    cc = ""
  ) {
    if (!pdfFile || sending || !pages.length) return;
    //if(contact_id == 0 && newUserName == "") return;
    sending = true;
    try {
      clipboardTxt = "";
      sendingSign = true;
      usersPanel = true;
      let body = await getSignatureOptions(contact_id);
      body.newName = newUserName;
      body.lang = smsLang;
      body.color = signColor;
      if (cblog != "") body.blog = cblog;
      body.tw_b_id = tw_b_id;
      body.phone = phone;
      body.email = email;
      body.user_id = shareUserId || (selectedChatUser && selectedChatUser.id) || "";
      body.user_name = shareUserName || (selectedChatUser && selectedChatUser.fullName) || "";
      body.user_caseFileId = merusCaseEnabled ? shareCaseFileId : "";
      body.user_matterId = fluentCaseEnabled ? matterId : "";
      body.cc = cc;
      body.staff_id = user.id;
      body.staff_email = user.email;
      body.staff_name = user.name;
      body.appId = user.appId;
      body.merusUserId = selectedMerusUserId;
      body.merusActivityTypeId = selectedMerusActivityTypeId;
      body.fluentCaseTagId = selectedFluentCaseTagId;
      body.sharepoint = selectedSharepoint;
      body.multiplePdfs = multiplePdfs;
      body.sendEmailSubject = emailSubject;
      body.emailCC = emailCC;
      body.fluentcaseToken = fluentCaseToken;
      body.send_type = sendPDFType;
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=updateContactPost",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      if (data) {
        if ( selectedEventType && sendPDFType != "link"  ) {

          const date = new Date();
          date.setDate(date.getDate() + parseInt(selectedEventNumberOfDays));

          let newEvent = {
            name: shareUserName + " - " + pdfName ,
            details: '',
            creator: '',
            eventDate: ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear(),
            eventTime: date.toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3"),
            eventTimestamp: +date,
            eventType: selectedEventType,
            location: '',
            members: [],
            timestamp: Date.now()
          };

          selectedChatUser.events.push(newEvent);
          
          fetch('https://api.qix.cloud/conversation', {
            method: 'PUT',
            body: JSON.stringify(selectedChatUser),
            headers: {
              'Content-Type': 'application/json',
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });


        }
      }
      //alert('Sent successfully!.');

      shareEmail = "";
      shareUserId = "";
      shareUserName = "";
      shareCaseFileId = "";
      if (sendPDFType == "link" || sendPDFType == "sms") {
        clipboardTxt = buildSignUrl(data.id);
      }
      sendPDFRes = true;
      await getUsersFunc();
    } catch (e) {
      console.log(e);
    } finally {
      sending = false;
      selectedUser = "";
    }
    sendingSign = false;
    smsLang = "";
    //usersPanel = false;
  }

  async function getUsersFunc() {
    const users_req = await fetch(
      blog.siteurl +
        "/wp-admin/admin-ajax.php?action=getCloudFlareAppUsers&auth=" +
        "google" +
        "&id=" +
        user.id +
        "&email=" +
        user.email
    );
    users = await users_req.json();
  }
  async function onRightClick(e) {
    if (previewMode) return;
    if (e.target.nodeName == "CANVAS") {
      if (showMenu) {
        showMenu = false;
        await new Promise((res) => setTimeout(res, 100));
      }
      pos = { x: e.clientX + wx, y: e.clientY + wy };
      layerPos = { x: e.layerX, y: e.layerY };
      showMenu = true;
    } else if (e.target.className.includes("Signature wrap")) {
      signColor = signColor == 0 ? 255 : 0;
      toggleSignImage();
    }
  }
  async function toggleSignImage() {
    let tempObjects = allObjects;
    for (var i = 0; i < tempObjects.length; i++) {
      for (var j = 0; j < tempObjects[i].length; j++) {
        let obj = tempObjects[i][j];
        if (obj.type == "Signature") {
          selectedPageIndex = i;
          deleteObject(obj.id);
          layerPos = { x: obj.x, y: obj.y };
          await addSignImage("", 1);
        }
      }
    }
  }
  function closeMenu() {
    showMenu = false;
  }
  function closeAddTextMenu() {
    addTextMenu = false;
  }
  async function addSignImage(url = "", p) {
    try {
      if (url == "") {
        if (signColor == 0) {
          url = "https://qix.cloud/img/sign_hear.png";
        } else {
          url = "https://qix.cloud/img/sign_hear.png";
        }
      }
      // get dataURL to prevent canvas from tainted
      const file = url;
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      console.log(width, height, "width height app");
      signatureMenu = false;
      const object = {
        id,
        type: "Signature",
        width,
        height,
        x: layerPos.x,
        y: layerPos.y,
        payload: img,
        file,
      };
      if (p == 0) {
        object.x = 0;
        object.y = 0;
      }
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }
  async function addQuickSignImage(url, p) {
    try {
      // get dataURL to prevent canvas from tainted
      const file = url;
      const img = await readAsImage(url);
      const id = genID();
      const { width, height } = img;
      signatureMenu = false;
      const object = {
        id,
        type: "quickSign",
        width,
        height,
        x: layerPos.x,
        y: layerPos.y,
        payload: img,
        file,
      };
      if (p == 0) {
        object.x = 0;
        object.y = 0;
      }
      allObjects = allObjects.map((objects, pIndex) =>
        pIndex === selectedPageIndex ? [...objects, object] : objects
      );
    } catch (e) {
      console.log(`Fail to add image.`, e);
    }
  }
  async function showSignatureTabFunc() {
    //if (blog != "") {
    pendingSignature = [];
    completedSignature = [];
    signatureTabLoading = true;
    showSignatureTab = true;
    showRenameTemp = false;
    selectedSginTab = "pending";
    // Re-fetch team so menu/signature flows always have fresh teammates
    await refreshTeam();
    let body = {
      auth: "google",
      user_id: user.id,
      app_id: user.appId,
      email: user.email,
      blog_id: blog.blog_id,
      team: friends
    };
    const req = await fetch(
      blog.siteurl +
        "/wp-admin/admin-ajax.php?action=getSignatureListForCloudflare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let data = await req.json();
    pendingSignature = data.pending;
    showArchive = false;
    completedSignature = data.completed;
    templates = data.templates;
    if (users.length < 1) {
      await getUsersFunc();
    }
    getSignatures();
    //getFriends();
    signatureTabLoading = false;
    //}
  }

  async function showNewProfileFunc() {
    //if (blog != "") {
    // pendingSignature = [];
    // completedSignature = [];
    displayLeftMenu = false;
    newProfilePanel = true;
    showRenameTemp = false;
    selectedSginTab = "pending";
    // Re-fetch /team every time main menu opens (avoids stale/empty friends after reload)
    await refreshTeam();
    if( false) {
      let body = {
        auth: "google",
        user_id: user.id,
        app_id: user.appId,
        email: user.email,
        blog_id: blog.blog_id,
        team: friends
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=getSignatureListForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      pendingSignature = data.pending;
      showArchive = false;
      completedSignature = data.completed;
      templates = data.templates;
    }
    if (users.length < 1) {
      await getUsersFunc();
    }
    getSignatures();
    //getFriends();
    //}
  }

  /** Fetch https://api.qix.cloud/team and refresh friends + integration tokens */
  async function refreshTeam() {
    if (mockMode) return;
    if (!localStorage.getItem("token")) return;
    try {
      const info = await getTeam();
      friends = Array.isArray(info) ? info : [];
      for (const friend of friends) {
        const settings = friend && friend.settings ? friend.settings : null;
        if (!settings) continue;

        const hasMerus = !!(settings.merusCase && settings.merusCase.enabled == true);
        const hasFluent = !!(settings.fluentCase && settings.fluentCase.enabled == true);
        if (!hasMerus && !hasFluent) continue;

        let viewSettingsAvailable = false;
        try {
          viewSettingsAvailable = await getTeamShareSettingsAvailable(friend.id);
        } catch (_) {
          viewSettingsAvailable = false;
        }
        if (!viewSettingsAvailable) continue;

        if (hasMerus) {
          merusCaseEnabled = true;
          merusToken = settings.merusCase.token;
        }
        if (hasFluent) {
          fluentCaseEnabled = true;
          fluentCaseToken = settings.fluentCase.token;
        }
      }
      updateAutomationTitle();
    } catch (err) {
      console.log("refreshTeam failed", err);
    }
  }

  function hideSignatureTabFunc() {
    showSignatureTab = false;
  }
  async function deleteSignature(id) {
    if (confirm("Are you sure you want to delete the signature?") == true) {
      signatureTabLoading = true;
      let body = {
        id: id,
        auth: "google",
        user_id: user.id,
        email: user.email,
        team: friends,
      };
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=deleteSignatureProcess",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      pendingSignature = data.pending;
      showArchive = false;
      completedSignature = data.completed;
      templates = data.templates;
      signatureTabLoading = false;
    }
  }
  async function deleteArchivedSignature(id) {
    if (confirm("Are you sure you want to delete the signature?") == true) {
      signatureTabLoading = true;
      let body = {
        id: id,
        auth: "google",
        user_id: user.id,
        email: user.email,
        team: friends,
      };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=deleteArchivedSignature",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      completedArchived = await req.json();
      signatureTabLoading = false;
    }
  }
  async function getArchivedSignature() {
    if (mockMode) {
      // Keep production-like mock archive rows (avoid live API wipe)
      if (!Array.isArray(completedArchived) || completedArchived.length === 0) {
        completedArchived = [
          {
            id: 'a1',
            pdfName:
              'Archived_Settlement_Release_Client_Very_Long_Document_Name_Final.pdf',
            date: '04/12/2026',
            attachmentUrl: 'https://qix.cloud/mock/archived1.pdf',
          },
          {
            id: 'a2',
            pdfName: 'Old Engagement Letter.pdf',
            date: '03/01/2026',
            attachmentUrl: 'https://qix.cloud/mock/archived2.pdf',
          },
        ];
      }
      signatureTabLoading = false;
      return;
    }
    signatureTabLoading = true;
    let body = {
      auth: "google",
      user_id: user.id,
      email: user.email,
      team: friends,
    };
    const req = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=getArchivedSignature",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    completedArchived = await req.json();
    signatureTabLoading = false;
  }
  async function deleteQuickSignature(id) {
    if (confirm("Are you sure you want to delete the signature?") == true) {
      signatureTabLoading = true;
      let body = { id: id };
      const req = await fetch(
        blog.siteurl +
          "/wp-admin/admin-ajax.php?action=deleteQuickSignatureProcess",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      quickSigns = await req.json();
      signatureTabLoading = false;
    }
  }
  async function resendSignature(id) {
    if (confirm("Are you sure you want to resend the signature?") == true) {
      signatureTabLoading = true;
      let body = { id: id };
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=resendSignatureProcess",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      alert("Sent!");
    }
  }
  function changeSignatureTabFunc(tab) {
    selectedSginTab = tab;
    if (selectedSginTab == "templates") {
      completedSaveTemplate = false;
    }
  }
  async function shareSignature(title, text, url) {
    const shareData = {
      title: title,
      text: text,
      url: url,
    };
    try {
      await navigator.share(shareData);
      //alert('Shared successfully');
    } catch (err) {
      alert(err);
    }
  }
  async function shareFunc() {
    if (selectedPageIndex >= 0 || mockMode) {
      usersPanel = false;
      sharePanel = true;
      if (!mockMode) await getUsersFunc();
    }
  }
  function handleClickOutsideSharePanel() {
    sharePanel = false;
  }
  function closeUsersPanel() {
    usersPanel = false;
  }
  function showSignatureMenu() {
    if (selectedPageIndex >= 0) {
      signatureMenu = true;
    }
  }
  function showPacketMenu() {
    if (selectedPageIndex >= 0) {
      packetMenu = true;
    }
  }

  function showAddTextMenu() {
    if (selectedPageIndex >= 0) {
      addTextMenu = true;
    }
  }

  function handleClickOutsideAddTextMenu() {
    addTextMenu = false;
  }

  function handleClickOutsideSignatureMenu() {
    signatureMenu = false;
    packetMenu = false;
  }
  function handleClickOutsideSignInPanel() {
    loginPanel = false;
  }
  function handleClickOutsideSignatureTab() {
    showSignatureTab = false;
  }
  function handleClickOutsideLogoutPanel() {
    logoutpanel = false;
  }
  function showlogoutpanel() {
    logoutpanel = true;
  }
  function showNewUserPanel() {
    sendingNewUserType = 0;
    sendingNewUser = false;
    newUserPanel = true;
  }
  function showEmailPanel(status) {
    shareEmail = "";
    console.log("showEmailPanel", status);
    checkIfEmailFunc();
    emailPanel = status;
  }
  function showEmailCCPanel(status) {
    shareEmailcc = "";
    emailCCPanel = status;
  }
  function checkIfEmailFunc() {
    // Regular expression to check if string is email
    const regexExp =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

    checkIfEmail = regexExp.test(shareEmail);
  }
  function hideNewUserPanel() {
    newUserPanel = false;
    display_name_panel = false;
  }
  async function addNewUser() {
    if (userName != "" && userPhone != "") {
      sendingNewUser = true;
      sendingNewUserType = 0;
      const req = await fetch(
        "https://qix.cloud/wp-admin/admin-ajax.php?action=addNewConversationCloudFlare",
        {
          method: "POST",
          body: JSON.stringify({
            name: userName,
            phone: userPhone,
            auth: "google",
            id: user.id,
          }),
        }
      );
      let data = await req.json();
      users = data.users;
      selectedUser = data.contact_id;
      if (data.type > 0) {
        sendingNewUserType = 1;
      } else {
        sendingNewUser = false;
        newUserPanel = false;
        sendSignature(data.contact_id);
      }
    }
  }

  async function continueSendSignature() {
    sendingNewUserType = 0;
    sendingNewUser = false;
    newUserPanel = false;
    sendSignature(selectedUser);
  }
  function checkUserPhone() {
    let l = userPhone.length;
    let newValue = userPhone.replace(/\D+/g, "");
    userPhone = formatToTelephone(newValue, l);
  }
  function formatToTelephone(str, l) {
    var splitString = str.split(""),
      returnValue = "";

    for (var i = 0; i < splitString.length; i++) {
      var currentLoop = i,
        currentCharacter = splitString[i];

      switch (currentLoop) {
        case 0:
          returnValue = returnValue.concat("(");
          returnValue = returnValue.concat(currentCharacter);
          break;
        case 2:
          returnValue = returnValue.concat(currentCharacter);
          if (l > 6) returnValue = returnValue.concat(") ");
          break;
        case 5:
          returnValue = returnValue.concat(currentCharacter);
          if (l > 10) returnValue = returnValue.concat("-");
          break;
        default:
          returnValue = returnValue.concat(currentCharacter);
      }
    }
    return returnValue;
  }
  async function handleLoadTemplate(event) {
    console.log("handleLoadTemplate in app", event);
    loadTemplate(event.detail.template);
  }

  // Packet menu delete: unload a loaded extra template from the current multi-PDF session
  function deleteTemplate(template) {
    if (template && typeof template === "object") {
      return loadExtraTemplate(template);
    }
  }

  async function loadExtraTemplate(template) {
    packetMenu = false;
    loadingTemplate = true;
    let body = { url: template.pdfUrl, auth: "google" };

    if (template.loaded) {
      if (multiplePdfs.length > 1) {
        let startPindex = 0;
        let endPindex = 0;
        let selectPindex = 0;
        for (let i = 0; i < multiplePdfs.length; i++) {
          if (selectPindex > 0) {
            multiplePdfs[i].pages = multiplePdfs[i].pages - startPindex;
          } else {
            if (multiplePdfs[i].id == template.id) {
              endPindex = multiplePdfs[i].pages;
              selectPindex = endPindex - startPindex;
            } else {
              startPindex = multiplePdfs[i].pages;
            }
          }
        }
        multiplePdfs = multiplePdfs.filter((pdfs, _) => pdfs.id != template.id);
        if (startPindex == 0) {
          const res = await fetch(
            blog.siteurl +
              "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
            {
              method: "POST",
              body: JSON.stringify(body),
            }
          );
          let pdfBlob = await res.blob();
          const pdf = await readAsPDF(pdfBlob);
          pdfName = template.pdfName;
          pdfFile = pdf;
        }
        allObjects = allObjects.filter(
          (_, pIndex) => !(pIndex >= startPindex && pIndex < endPindex)
        );
        pages = pages.filter(
          (_, pIndex) => !(pIndex >= startPindex && pIndex < endPindex)
        );
        pdfFiles = pdfFiles.filter((pdfFile, _) => pdfFile[1] != template.id);
        template.loaded = false;
        templates = templates.map((temp, tIndex) =>
          temp.id == template.id ? template : temp
        );
      }
    } else {
      const res = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let pdfBlob = await res.blob();
      const pdf = await readAsPDF(pdfBlob);
      // pdfName = file.name;
      // pdfFile = file;
      const numPages = pdf.numPages;
      const initPageNum = pages.length;
      pdfFiles.push([pdfBlob, template.id]);
      if (multiplePdfs.length == 0) {
        multiplePdfs.push({
          id: templateId,
          name: pdfName,
          pages: initPageNum,
          url: "",
        });
      }
      multiplePdfs.push({
        id: template.id,
        name: template.pdfName,
        pages: initPageNum + numPages,
        url: template.pdfUrl,
      });
      pages = [
        ...pages,
        ...Array.from({ length: numPages }, (_, i) => pdf.getPage(i + 1)),
      ];
      for (let i = 0; i < numPages; i++) {
        allObjects.push([]);
      }
      // pdfName = template.pdfName;
      let Objs = JSON.parse(template.allObjects);
      //console.log("Objs", Objs);
      for (var i = 0; i < Objs.length; i++) {
        for (var j = 0; j < Objs[i].length; j++) {
          let obj = Objs[i][j];
          layerPos = { x: obj.x, y: obj.y };
          selectedPageIndex = initPageNum + i;
          if (obj.type == "Signature") {
            await addSignImage(obj.file, 1);
          }
          if (obj.type == "quickSign") {
            await addQuickSignImage(obj.file, 1);
          }
          if (obj.type == "text") {
            addTextField(obj.text, true);
          }
        }
      }

      template.loaded = true;
      templates = templates.map((temp, tIndex) =>
        temp.id == template.id ? template : temp
      );
    }
    // templateId = template.id;
    setTimeout(function () {
      //window.scrollTo({ top: 0, behavior: "auto" });
      loadingTemplate = false;
    }, 1000);
  }
  async function loadTemplate(template) {
    console.log("loadTemplate", template);
    loadingTemplate = true;

    selectedMerusUserId = template.merusUserId ? template.merusUserId : null;
    selectedMerusActivityTypeId = template.activity_type_id ? template.activity_type_id : null;
    selectedFluentCaseTagId = template.fluent_tag_id ? template.fluent_tag_id : null;
    selectedSharepoint = template.sharepoint ? template.sharepoint : null;
    selectedEventType = template.event_type ? template.event_type : null;
    selectedEventNumberOfDays = template.event_number_of_days ? template.event_number_of_days : null;
    showSignatureTab = false;
    let body = { url: template.pdfUrl, auth: "google" };
    const res = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let pdfBlob = await res.blob();
    selectedPageIndex = 0;
    await addPDF(pdfBlob);
    pdfName = template.pdfName;
    let Objs = JSON.parse(template.allObjects);
    for (var i = 0; i < Objs.length; i++) {
      for (var j = 0; j < Objs[i].length; j++) {
        let obj = Objs[i][j];
        layerPos = { x: obj.x, y: obj.y };
        selectedPageIndex = i;
        if (obj.type == "Signature") {
          await addSignImage(obj.file, 1);
        }
        if (obj.type == "quickSign") {
          await addQuickSignImage(obj.file, 1);
        }
        if (obj.type == "text") {
          addTextField(obj.text, true);
        }
      }
    }
    //console.log(selectedPageIndex);
    templateId = template.id;
    template.loaded = true;
    templates = templates.map((temp, tIndex) =>
      temp.id == templateId ? template : temp
    );
    setTimeout(function () {
      window.scrollTo({ top: 0, behavior: "auto" });
      loadingTemplate = false;
    }, 1000);
  }
  async function loadDefaultDoc(index) {
    selectedPageIndex = 0;
    const res = await fetch("/pdfs/" + defaultDocs[index]);
    const pdfBlob = await res.blob();
    await addPDF(pdfBlob);
    pdfName = defaultDocs[index];
    updateDefaultDoc(index);
  }
  function isJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  async function editCompletedDoc(pdfs, name,attachmentUrl) {
    showSignatureTab = false;
    loadingTemplate = true;
    completedPDFUrl = attachmentUrl;
    let pdfUrl = pdfs;
    if (isJSON(pdfs)) {
      let pdfData = JSON.parse(pdfs);
      pdfUrl = blog.siteurl + pdfData[0].link;
      completedPDFUrl = pdfUrl;
    }
    let body = { url: pdfUrl, auth: "google" };
    const res = await fetch(
      blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let pdfBlob = await res.blob();
    selectedPageIndex = 0;
    await addPDF(pdfBlob);
    pdfName = name;
    loadingTemplate = false;
  }
  async function viewCompletedDoc(sign) {
    const pdfs = sign.signedPdf;
    if (isJSON(pdfs)) {
      let pdfData = JSON.parse(pdfs);
      pdfData.forEach((data, index) => {
        setTimeout(() => {
          window.open(blog.siteurl + data.link, "_blank");
        }, index * 500); // 500ms delay between tabs
      });
    } else {
      window.open(blog.siteurl + pdfs, "_blank");
    }
  }
  async function getDefaultDoc() {
    if (user.id != "") {
      let body = new URLSearchParams();
      body.append("action", "getDefaultPdfs");
      body.append("user_id", user.id);
      const req = await fetch("https://qix.cloud/ajax/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
      });
      const res = await req.json();
      if (res.length > 0) defaultDocs = res;
    }
  }
  async function updateDefaultDoc(index) {
    // Get the item at the specified index
    const selectedDoc = defaultDocs[index];
    // Create a new array with the selected item at the start, followed by the rest
    defaultDocs = [
      selectedDoc,
      ...defaultDocs.slice(0, index),
      ...defaultDocs.slice(index + 1),
    ];

    let body = new URLSearchParams();
    body.append("action", "updateDefaultPdfs");
    body.append("user_id", user.id);
    body.append("defaultDocs", JSON.stringify(defaultDocs)); // Convert array to JSON string
    const req = await fetch("https://qix.cloud/ajax/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    });
    let data = await req.json();
  }

  async function getPageDimension() {
    const pageData = await getPdfPageData(pdfFile);

    for (const [file] of pdfFiles) {
      const data = await getPdfPageData(file);
      pageData.push(...data);
    }

    return pageData;
  }
  // Helper function to merge all pages from pages array into a single PDF
  // Only merges base PDF pages without objects - getData() will add objects later
  async function mergeAllPagesIntoPDF() {
    try {
      const { getAsset } = await import('../../utils/prepareAssets.js');
      const PDFLib = await getAsset("PDFLib");
      
      // Create a new PDF document
      const mergedPdfDoc = await PDFLib.PDFDocument.create();
      
      // Process all pages from the pages array
      for (let i = 0; i < pages.length; i++) {
        let page = pages[i];
        
        // Resolve page if it's a promise
        if (page && typeof page.then === 'function') {
          page = await page;
        }
        
        // Get page dimensions
        const viewport = page.getViewport({ scale: 1 });
        const pageWidth = viewport.width;
        const pageHeight = viewport.height;
        
        // Render only the base PDF page to canvas (without objects)
        const SCALE = 3;
        const renderViewport = page.getViewport({ scale: SCALE });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.width = renderViewport.width;
        canvas.height = renderViewport.height;
        
        // Render the PDF page only (no objects - they'll be added by getData())
        await page.render({
          canvasContext: context,
          viewport: renderViewport
        }).promise;
        
        // Convert canvas to PNG and embed in PDF
        const imageBytes = await new Promise((resolve, reject) => {
          canvas.toBlob((blob) => {
            if (!blob) {
              reject(new Error("Failed to generate canvas blob"));
              return;
            }
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsArrayBuffer(blob);
          }, 'image/png');
        });
        
        const pngImage = await mergedPdfDoc.embedPng(imageBytes);
        const newPage = mergedPdfDoc.addPage([pageWidth, pageHeight]);
        newPage.drawImage(pngImage, {
          x: 0,
          y: 0,
          width: pageWidth,
          height: pageHeight,
        });
      }
      
      // Return the merged PDF as a Blob
      const pdfBytes = await mergedPdfDoc.save();
      return new Blob([pdfBytes], { type: 'application/pdf' });
    } catch (e) {
      console.log("Failed to merge pages into PDF:", e);
      // Fallback to original pdfFile if merge fails
      return pdfFile;
    }
  }

  async function getSignatureOptions(contact_id = 0) {
    // Merge all pages (including added ones) into a single PDF
    const mergedPdf = await mergeAllPagesIntoPDF();
    const prePdfData = await getData(mergedPdf, allObjects, pdfName);
    //let pdfData = "data:application/pdf;base64,"  +  prePdfData[0];
    let pdfData = typeof prePdfData[0] === 'string' ? prePdfData[0] : String(prePdfData[0]);
    pdfBlobFile = pdfData;
    let optionData = prePdfData[1];
    if (pdfFiles.length > 0) {
      let tempSignatures = [];
      const pageData = await getPageDimension();
      for (let pageIndex = 0; pageIndex < allObjects.length; pageIndex++) {
        const objects = allObjects[pageIndex];
        const pageWidth = pageData[pageIndex].width;
        const pageHeight = pageData[pageIndex].height;
        for (let i = 0; i < objects.length; i++) {
          const object = objects[i];
          if (object.type === "Signature") {
            let { file, x, y, width, height } = object;
            let tmp = {
              type: object.type,
              url: file,
              x,
              y,
              width,
              height,
              pageIndex,
              pageWidth,
              pageHeight,
            };
            tempSignatures.push(tmp);
          } else if (object.type === "quickSign") {
            let { file, x, y, width, height } = object;
            let tmp = {
              type: object.type,
              url: file,
              x,
              y,
              width,
              height,
              pageIndex,
              pageWidth,
              pageHeight,
            };
            tempSignatures.push(tmp);
          } else if (object.type === "text") {
            let { text, x, y, width,size} = object;
            let tmp = {
              type: object.type,
              text: text,
              x,
              y,
              width,
              pageIndex,
              pageWidth,
              pageHeight,
              size
            };
            tempSignatures.push(tmp);
          }
        }
      }
      optionData = tempSignatures;
    }
    let sign1 = "";
    let sign2 = "";
    let sign3 = "";
    let sign4 = "";
    let sign5 = "";
    let sign6 = "";
    for (let i = 0; i < optionData.length; i++) {
      const pageNum = optionData[i].pageIndex + 1;
      let pageWidth = optionData[i].pageWidth;
      let pageHeight = optionData[i].pageHeight;
      let size = optionData[i].size;
      if (pageWidth == 792 && pageHeight == 612) {
        if (optionData[0].pageWidth == 612 && optionData[0].pageHeight == 792) {
          pageWidth = 612;
          pageHeight = 792;
        }
      }
      if (optionData[i].type == "text") {
        //console.log(optionData[i].pageWidth, optionData[i].pageHeight);
        let posX = optionData[i].x / pageWidth;
        let posY = (optionData[i].y + 15) / pageHeight;
        if (optionData[i].text == "Initial") {
          if (sign2 == "") {
            sign2 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign2 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else if (optionData[i].text == "Date") {
          if (sign3 == "") {
            sign3 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign3 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else if (optionData[i].text == "Name") {
          if (sign4 == "") {
            sign4 += pageNum + ":" + posX + ":" + posY + ":" + size;
          } else {
            sign4 += "," + pageNum + ":" + posX + ":" + posY + ":" + size;
          }
        } else {
          //console.log("optionData", i, optionData);
          if (sign5 == "") {
            sign5 +=
              pageNum + ":" + posX + ":" + posY + ":" + optionData[i].text.replace(/,/g, "-*-").replace(/:/g, "_*_") + ":" + size;
          } else {
            sign5 +=
              "," +
              pageNum +
              ":" +
              posX +
              ":" +
              posY +
              ":" +
              optionData[i].text.replace(/,/g, "-*-").replace(/:/g, "_*_") + ":" + size;
          }
        }
      } else {
        let posX = optionData[i].x / pageWidth;
        let posY = optionData[i].y / (pageHeight - 23);
        if (optionData[i].type == "quickSign") {
          let path = optionData[i].url.replace(blog.siteurl, "");
          if (sign6 == "") {
            sign6 += pageNum + ":" + posX + ":" + posY + ":" + path;
          } else {
            sign6 += "," + pageNum + ":" + posX + ":" + posY + ":" + path;
          }
        }
        if (optionData[i].type == "Signature") {
          if (sign1 == "") {
            sign1 += pageNum + ":" + posX + ":" + posY;
          } else {
            sign1 += "," + pageNum + ":" + posX + ":" + posY;
          }
        }
      }
    }
    let timestamp = 0;
    let option1 = sign1 + "--*--" + sign3;
    let option2 =
      sign2 +
      "--*--" +
      sign4 +
      "--*--" +
      sign5 +
      "--*--letter--*--" +
      timestamp +
      "--*--" +
      sign6;
    let display_name = "google_" + user.name;
    let body = {
      author_id: user.id,
      author: display_name,
      contact_id: contact_id,
      pdfData: pdfData,
      pdfName: pdfName && !pdfName.toLowerCase().endsWith('.pdf') ? pdfName + '.pdf' : pdfName,
      option1: option1,
      option2: option2,
      sendPDFType: sendPDFType,
      allObjects: allObjects,
    };
    return body;
  }
  async function saveTemplate() {
    processingSaveTemplate = true;
    completedSaveTemplate = false;
    let body = await getSignatureOptions();
    body.templateId = templateId;
    body.thumbnail = tempThumb;
    body.auth = "google";
    //console.log("body", body);
    const res = await fetch(
      blog.siteurl +
        "/wp-admin/admin-ajax.php?action=saveTemplateFromCloudFlare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let data = await res.json();
    templateId = data;
    
    if (user.id != "") {
      let body = {
        auth: "google",
        user_id: user.id,
        app_id: user.appId,
        email: user.email,
        team: friends,
      };
      const req = await fetch(
        "https://qix.cloud" +
        "/wp-admin/admin-ajax.php?action=getSignatureListForCloudflare",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      pendingSignature = data.pending;
      showArchive = false;
      completedSignature = data.completed;
      templates = data.templates;
    }
    processingSaveTemplate = false;
    completedSaveTemplate = true;
    setTimeout(() => {
      completedSaveTemplate = false;
    }, 1500);
    showSignatureTab = false;
  }
  async function showNewSignPanel(status) {
    newSignPanel = status;
  }
  async function getSignatures() {
    if (quickSigns.length < 1) {
      let body = {
        auth: "google",
        user_id: user.id,
        email: user.email,
      };
      const signs_req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=getSignItQuickSign",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      quickSigns = await signs_req.json();
    }
  }
  async function getFriends() {
    if (friends.length < 1) {
      let body = {
        auth: "google",
        user_id: user.id,
        name: user.name,
        email: user.email,
        blog_id: blog.blog_id,
      };
      const res = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=getGoogleFriends",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      friends = await res.json();
    }
  }
  async function saveNewSignature() {
    let body = {
      name: newSignName,
      phone: newSignPhone,
      auth: "google",
      user_id: user.id,
    };
    const req = await fetch(
      blog.siteurl +
        "/wp-admin/admin-ajax.php?action=updateSignItQuickSignCloudflare",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    signUrl = toPublicSignUrl(res.url);
    getSignatures();
  }
  async function checkallObjects() {
    newUserName = "";
    display_name_panel = false;
    for (var i = 0; i < allObjects.length; i++) {
      for (var j = 0; j < allObjects[i].length; j++) {
        let obj = allObjects[i][j];
        if (obj.type == "text") {
          if (obj.text == "Initial" || obj.text == "Name") {
            if (!display_name_panel) {
              showNewUserPanel();
              display_name_panel = true;
            }
          }
        }
      }
    }
    if (!display_name_panel) {
      sendSignature(0);
    }
  }
  async function deleteFriend(id) {
    if (confirm("Are you sure you want to remove the friend?") == true) {
      signatureTabLoading = true;
      let body = { id: id };
      await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=deleteGoogleFriend",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      getSignatures();
    }
  }
  function startTutorial(id) {
    const middle = document.body.scrollHeight / 3;
    window.scrollTo({ top: middle, behavior: "auto" });
    console.log("Starting tutorial:", id);
    tutorialPanel = false;
    displayTutorial(2, id); // Example function call
  }
  async function displayTutorialPage() {
      tutorialPanel = true;
  }
  async function displayTutorial(step, tutorialNum = 0) {
    console.log("Step:", step, "Tutorial Number:", tutorialNum);
    tutorialPanel = false;
    tutorialNumber = tutorialNum;

    if (step === -1) {
      tutorialStep = (tutorialStep < 5) ? tutorialStep + 1 : 0;
    } else {
      tutorialStep = step;
    }

    switch (tutorialNumber) {
      case 0:
        editDocumentTutorial(tutorialStep);
        break;
      case 1:
        newDocumentTutorial(tutorialStep);
        break;
      case 2:
        createTemplateTutorial(tutorialStep);
        break;
      case 3:
        createPacketTutorial(tutorialStep);
      break;
      case 4:
        automateTemplateTutorial(tutorialStep);
        break;
      case 5:
        automateTemplateSharepointTutorial(tutorialStep);
        break;
      case 6:
        addTeamMembersTutorial(tutorialStep);
        break;
      case 7:
        loadArchivedDocumentsTutorial(tutorialStep);
        break;
      case 8:
        changeTheSignatureColorTutorial(tutorialStep);
        break;
      case 9:
        // showNewProfileFunc();
        AddCustomFieldsToSignatureTutorial(tutorialStep);
        break;
    }

  }
  function editDocumentTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        signatureMenu = true;
        loadDefaultDoc(0);
        break;
      case 4:
        layerPos = { x: 50, y: 710 };
        selectedPageIndex = 1;
        addSignImage("", 0);
        window.scrollTo(0, document.body.scrollHeight);
        break;
      case 5:
        layerPos = { x: 350, y: 710 };
        selectedPageIndex = 1;
        addTextField("Name", true);
        break;
    }
  }
  function newDocumentTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        signatureMenu = true;
        loadDefaultDoc(0);
        break;
      case 4:
        layerPos = { x: 500, y: 710 };
        // selectedPageIndex = 1;
        addSignImage("", 1);
        window.scrollTo(0, document.body.scrollHeight);
        break;
      case 5:
        layerPos = { x: 350, y: 710 };
        selectedPageIndex = 1;
        addTextField("Name", true);
        break;
      case 6:
      showNewProfileFunc();
      break;
    }
  }
  function createTemplateTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        signatureMenu = true;
        loadDefaultDoc(0);
        break;
      case 4:
        layerPos = { x: 500, y: 710 };
        // selectedPageIndex = 1;
        addSignImage("", 1);
        layerPos = { x: 500, y: 510 };
        addTextField("Name", true);
        layerPos = { x: 500, y: 310 };
        addTextField("Date", true);
        window.scrollTo(0, document.body.scrollHeight);
        break;
      case 5:
        layerPos = { x: 350, y: 710 };
        selectedPageIndex = 1;
        showNewProfileFunc();
        break;
      case 6:
        // showNewProfileFunc();
        activeTab = Tab.Templates;
      break;
      case 7:
        // showNewProfileFunc();
        // changeSignatureTabFunc("templates");
      break;
    }
  }

  function createPacketTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        // signatureMenu = true;
        // loadDefaultDoc(0);
        showNewProfileFunc();
        activeTab = Tab.Templates;
        // showSignatureTabFunc();
        // changeSignatureTabFunc("templates");
        break;
      case 4:
        // showSignatureTabFunc();
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;
      case 5:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;
      case 6:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;
      case 7:
        // showSignatureTab   = true;
        // selectedSginTab = "templates";
        break; 
      case 8:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;    
  
    }
  }

  function automateTemplateTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        // signatureMenu = true;
        // loadDefaultDoc(0);
        // showSignatureTabFunc();
        showNewProfileFunc();
        activeTab = Tab.Templates;
        // changeSignatureTabFunc("templates");
        break;
      case 4:
        // showSignatureTabFunc();
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;
      case 5:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;
      case 6:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;
      case 7:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break; 
      case 8:
        // showSignatureTab = true;
        // selectedSginTab = "templates";
        break;    
  
    }
  }

  function automateTemplateSharepointTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        showNewProfileFunc();
        activeTab = Tab.Templates;
        break;
      case 4:
        break;
      case 5:
        break;
      case 6:
        break;
      case 7:
        break; 
      case 8:
        break;    
  
    }
  }

  function addTeamMembersTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        // signatureMenu = true;
        // loadDefaultDoc(0);
        showNewProfileFunc();
        activeTab = Tab.Team;
        // showSignatureTabFunc();
        // changeSignatureTabFunc("friends");
        break;
      case 4:
        // showSignatureTabFunc();
        // showSignatureTab = true;
        // selectedSginTab = "friends";
        break;
      case 5:
        // showSignatureTab = true;
        // selectedSginTab = "friends";
        break;
      case 6:
        activeTab = Tab.Templates;
        break;
      case 7:
        break; 
      case 8:
        break;    
  
    }
  }

  
  function loadArchivedDocumentsTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        // signatureMenu = true;
        // loadDefaultDoc(0);
        showNewProfileFunc();
        activeTab = Tab.Completed;
        break;
      case 4:
        // showSignatureTabFunc();
        displayArchive();
        break;
      case 5:
        break;
      case 6:
        break;  
    }
  }

  
  function changeTheSignatureColorTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        signatureMenu = true;
        loadDefaultDoc(0);
        break;
      case 4:
        layerPos = { x: 500, y: 710 };
        // selectedPageIndex = 1;
        addSignImage("", 1);
        window.scrollTo(0, document.body.scrollHeight);
        break;
    }
  }


  
  function AddCustomFieldsToSignatureTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        loadDefaultDoc(0);
        break;
      case 4:
          break;
      case 5:
          layerPos = { x: 500, y: 710 };
          addTextField("Entry Required", true);
          break;
    }
  }


  function openLeftMenu() {
    displayLeftMenu = true;
  }
  function closeLeftMenu() {
    displayLeftMenu = false;
  }
  function displayLeftMenuFunc() {
    displayLeftMenu = !displayLeftMenu;
  }
  async function getMerusToken() {
    let body = {
      appId: user.appId,
    };
    const req = await fetch("https://qix.cloud/ajax/meruscase.php", {
      method: "POST",
      body: JSON.stringify(body),
    });
    let res = await req.json();
    if (res.token != "") {
      merusToken = res.token;
    }
    //console.log("merusToken", merusToken);
  }
  function updateSendToId(id) {
    sendToId = sendToId == id ? 0 : id;
    // sendToType = "";
    // merusToken = "";
    // caseFileId = "";
    // merusTokenPanel = false;
  }
  async function sendToFunc(event) {
    if (event.detail.error == "") {
      updateSendToId(event.detail.signId);
      alert("Sent successfully!");
    } else {
      alert(event.detail.error);
    }
  }
  async function handleLogoUpload(img) {
    logo = img.replace(
      "https://drive.google.com/uc?export=view&id=",
      "https://lh3.google.com/u/0/d/"
    );
    let body = { appId: user.appId, email: user.email, logo: logo };
    const req = await fetch(blog.siteurl + "/ajax/logo.php", {
      method: "POST",
      body: JSON.stringify(body),
    });
    await req.json();
  }
  async function getEmailNotifyAvailable(status = "") {
    let body = { user_id: user.appId };
    if (status != "") {
      body = { user_id: user.appId, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/sender_notify_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    emailNotifyAvailable = res.available == "disable" ? false : true;
  }
    async function getTeamViewCompletedDocAvailable(status = "") {
    let body = { user_id: user.appId };
    if (status != "") {
      body = { user_id: user.appId, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/view_completed_documents_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    teamViewCompletedDocAvailable = res.available == "disable" ? false : true;
  }

  async function getShareSettingsAvailable(status = "") {
    let body = { user_id: user.id };
    if (status != "") {
      body = { user_id: user.id, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/share_settings_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    shareSettingsAvailable = res.available == "disable" ? false : true;
  }

  async function getTeamShareSettingsAvailable(userId) {
    let body = { user_id: userId };

    const req = await fetch(
      blog.siteurl + "/ajax/share_settings_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    return res.available == "disable" ? false : true;
  }



  async function getContactPost(contactPostId) {
    let body = { contactPostId: contactPostId };

    const req = await fetch(
      blog.siteurl + "/ajax/getContactPost.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    return buildAllContactPosts(res);
  
  }

  async function getSignedPdfsFromContactId(id) {
    const body = { contactPostId: String(id) };
    console.log("getSignedPdfsFromContactId request", body);
    // Browser call (same as before) — server-side POSTs to qix.cloud get Cloudflare 403
    const req = await fetch(
      blog.siteurl + "/ajax/getSignedPDFsFromContactId.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "text/plain;charset=UTF-8",
        },
        body: JSON.stringify(body),
      }
    );
    if (!req.ok) {
      throw new Error(
        `getSignedPDFsFromContactId failed with status ${req.status}`
      );
    }
    const res = await req.json();
    console.log("getSignedPdfsFromContactId response", res);
    if (Array.isArray(res)) return res;
    if (res && Array.isArray(res.data)) return res.data;
    if (res && Array.isArray(res.signedPdfs)) return res.signedPdfs;
    throw new Error("Unexpected signed PDFs response format");
  }

  async function isPdfBlob(blob) {
    if (!blob || blob.size === 0) return false;
    try {
      const header = await blob.slice(0, 5).text();
      return header.startsWith("%PDF");
    } catch (_) {
      return false;
    }
  }

  function toQixPath(pdfUrl) {
    if (!pdfUrl) return "";
    if (pdfUrl.startsWith("http")) {
      try {
        const u = new URL(pdfUrl);
        return u.pathname + u.search;
      } catch (_) {
        return pdfUrl;
      }
    }
    return pdfUrl.startsWith("/") ? pdfUrl : "/" + pdfUrl;
  }

  async function fetchPdfBlobFromUrl(pdfUrl) {
    console.log("fetchPdfBlobFromUrl", pdfUrl);
    const qixPath = toQixPath(pdfUrl);

    const origin =
      typeof window !== "undefined" ? window.location.origin : "";
    const sameOriginProxy = origin
      ? `${origin}/signed-pdf-proxy?path=${encodeURIComponent(qixPath)}`
      : null;

    const proxyUrls = [
      sameOriginProxy,
      `https://legalpal.app/signed-pdf-proxy?path=${encodeURIComponent(qixPath)}`,
    ].filter(Boolean);

    for (const proxyUrl of proxyUrls) {
      try {
        const res = await fetch(proxyUrl);
        if (!res.ok) continue;
        const blob = await res.blob();
        if (await isPdfBlob(blob)) {
          console.log("fetchPdfBlobFromUrl via proxy", proxyUrl);
          return blob;
        }
      } catch (e) {
        console.warn("proxy attempt failed", proxyUrl, e);
      }
    }

    // WordPress proxy — url only (signed files are on qix disk)
    try {
      const res = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare",
        {
          method: "POST",
          body: JSON.stringify({ url: pdfUrl }),
          credentials: "include",
        }
      );
      if (res.ok) {
        const blob = await res.blob();
        if (await isPdfBlob(blob)) {
          console.log(
            "fetchPdfBlobFromUrl via loadTemplateCloudFlare (url only)"
          );
          return blob;
        }
      }
    } catch (e) {
      console.warn("loadTemplateCloudFlare url-only failed", e);
    }

    throw new Error(`Could not load PDF bytes for: ${pdfUrl}`);
  }

  /**
   * Client-side signedContact merge/preview (best quality):
   * fetch each original PDF and append pages in the editor.
   * Backend /mergeSignedContactPdfs remains available for other apps.
   */
  async function loadSignedContactPreview(id) {
    loadingTemplate = true;
    showSignatureTab = false;
    signedContactBlobs = [];
    try {
      const signedPdfs = await getSignedPdfsFromContactId(id);
      if (!Array.isArray(signedPdfs) || signedPdfs.length === 0) {
        throw new Error("No signed PDFs found for this contact");
      }

      const first = signedPdfs[0];
      const firstLink = first.link || "";
      const firstUrl = firstLink.startsWith("http")
        ? firstLink
        : blog.siteurl +
          (firstLink.startsWith("/") ? firstLink : "/" + firstLink);

      let pdfBlob = await fetchPdfBlobFromUrl(firstUrl);
      signedContactBlobs = [pdfBlob];
      selectedPageIndex = 0;
      await addPDF(pdfBlob);
      pdfName = first.name || `signed_${id}.pdf`;

      for (let index = 1; index < signedPdfs.length; index++) {
        const item = signedPdfs[index];
        const link = item.link || "";
        const pdfUrl = link.startsWith("http")
          ? link
          : blog.siteurl + (link.startsWith("/") ? link : "/" + link);

        const extraBlob = await fetchPdfBlobFromUrl(pdfUrl);
        signedContactBlobs = [...signedContactBlobs, extraBlob];
        const pdf = await readAsPDF(extraBlob);
        const numPages = pdf.numPages;
        const initPageNum = pages.length;

        pdfFiles.push([
          extraBlob,
          item.envelopedId || item.name || String(index),
        ]);
        if (multiplePdfs.length == 0) {
          multiplePdfs.push({
            id: first.envelopedId || "0",
            name: pdfName,
            pages: initPageNum,
            url: firstUrl,
          });
        }
        multiplePdfs.push({
          id: item.envelopedId || String(index),
          name: item.name || `signed_${index + 1}.pdf`,
          pages: initPageNum + numPages,
          url: pdfUrl,
        });
        pages = [
          ...pages,
          ...Array.from({ length: numPages }, (_, i) => pdf.getPage(i + 1)),
        ];
        for (let i = 0; i < numPages; i++) {
          allObjects.push([]);
          pagesScale.push(1);
        }
      }

      try {
        sessionStorage.removeItem("signPreview_signedContact");
      } catch (_) {}
    } finally {
      loadingTemplate = false;
    }
  }

  function buildAllContactPosts(data) {
    const original = data.contactPost;
    const multiplePdfs = JSON.parse(data.multiplePdfs);

    // Start with the original contactPost
    const contactPosts = [original];

    // If there are more PDFs, convert them to contactPost format
    if (Array.isArray(multiplePdfs) && multiplePdfs.length > 0) {
      const extraPosts = multiplePdfs
        .filter(pdf => pdf.name !== original.attachmentName)
        .map(pdf => ({
          ...original,
          id: pdf.id, // Use the PDF ID to distinguish
          attachmentUrl: pdf.url,
          attachmentName: pdf.name,
          allObjects: pdf.allObjects
        }));

      contactPosts.push(...extraPosts);
    }

    return contactPosts;
  }

    async function getEmailSettings() {
    let body = { user_id: user.id };

    const req = await fetch(
      blog.siteurl + "/ajax/emailSettings.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    emailSubject = res.sentEmailSubject != "" ? res.sentEmailSubject : "Hello [user_name], [staff_name] here with the document link / [company_name]";
    emailCC = res.cc != "" ? res.cc : "";
    return emailSubject;
  }
  
  // async function getFluentCaseToken() {
  //   let body = { user_id: user.appId };

  //   const req = await fetch(
  //     blog.siteurl + "/ajax/fluentCaseToken.php",
  //     {
  //       method: "POST",
  //       body: JSON.stringify(body),
  //     }
  //   );
  //   let res = await req.json();
  //   fluentCaseToken = res.token != "" ? res.token : fluentCaseToken;
    
  //   return fluentCaseToken;
  // }

    async function postPdfFluentCase() {

      let body = {
         user_id: user.appId,
         matterId: matterId,
         attachmentUrl: completedPDFUrl,
         attachmentName: pdfName,
         pdfFile: pdfBlobFile,
         fluentCaseToken: fluentCaseToken
      };


      const req = await fetch(
        blog.siteurl + "/ajax/fluentcase.php",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      uploadedToFluentCase = true;
      let res = await req.json();
    }

  // async function setFluentCaseToken(token = "") {
  //   let body = { user_id: user.appId };
  //   if (token != "") {
  //     body = { user_id: user.appId, token: token };
  //   }
  //   const req = await fetch(
  //     blog.siteurl + "/ajax/fluentCaseToken.php",
  //     {
  //       method: "POST",
  //       body: JSON.stringify(body),
  //     }
  //   );
  //   let res = await req.json();
  //   fluentCaseToken = res.token != "" ? token : "";

  // }

  async function editTemplatesAvailableFunc(status = "") {
    let body = { user_id: user.appId };
    if (status != "") {
      body = { user_id: user.appId, available: status };
    }
    const req = await fetch(
      blog.siteurl + "/ajax/edit_template_available.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    editTemplatesAvailable = res.available == "disable" ? false : true;
  }

  async function displayArchive() {
    await getArchivedSignature();
    showArchive = true; //!showArchive;
  }
</script>
<Packets
{templates}
{blog}
{user}
{chatUsers}
{merusToken}
{tutorialNumber}
{tutorialStep}
bind:emailSubject={emailSubject}
bind:emailCC={emailCC}
bind:friends={friends}
bind:twilioEnabled={twilioEnabled}
bind:this={packetsRef}
/>
<!-- <svelte:window
  bind:scrollX={wx}
  bind:scrollY={wy}
  on:dragenter|preventDefault
  on:dragover|preventDefault
  on:drop|preventDefault={onUploadPDF}
  on:contextmenu|preventDefault={onRightClick}
/> -->
<svelte:window
  bind:scrollX={wx}
  bind:scrollY={wy}
  on:dragenter|preventDefault
  on:dragover|preventDefault
  on:drop|preventDefault={onUploadPDF}
/>
{#if firstLoading}
  <style>
    .signaturetab {
      max-width: 100vw;
      position: absolute;
      right: 5px;
      top: 50px;
      min-width: 220px;
    }
    .signItem {
      border: 1px solid;
      border-radius: 5px;
      padding: 10px;
      margin: 0 10px 10px;
    }
    .signItem .action {
      justify-content: space-between;
    }
    .signItem .action > div > span,
    .signItem .action > div > a {
      margin-right: 20px;
      color: #4299e1;
      cursor: pointer;
    }
    .signItem .action > div > span.delete {
      margin-right: 0;
      color: red;
      cursor: pointer;
    }
    .signItem .signed {
      white-space: nowrap;
      margin-right: 30px;
    }
    .tab-container {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tab-container .tabs {
      display: flex;
      position: relative;
      padding: 0.75rem;
    }
    .tab-container .tabs * {
      z-index: 2;
    }
    .tab-container input[type="radio"] {
      display: none;
    }
    .tab-container .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45px;
      width: 150px;
      font-weight: 500;
      border-radius: 99px;
      cursor: pointer;
      transition: color 0.15s ease-in;
    }
    .tab-container .notification {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2rem;
      height: 2rem;
      margin-left: 0.75rem;
      border-radius: 50%;
      background-color: #c1dcf1;
      transition: 0.15s ease-in;
    }
    .tab-container input[type="radio"]:checked + label {
      /* color: #185ee0; */
      background: #c1dcf1;
    }
    .tab-container input[type="radio"]:checked + label > .notification {
      background-color: #185ee0;
      color: #fff;
    }
    .tab-container input[id="radio-1"]:checked ~ .glider {
      transform: translateX(0);
    }
    .tab-container input[id="radio-2"]:checked ~ .glider {
      transform: translateX(100%);
    }
    .tab-container input[id="radio-3"]:checked ~ .glider {
      transform: translateX(200%);
    }
    .tab-container input[id="radio-4"]:checked ~ .glider {
      transform: translateX(300%);
    }
    .tab-container input[id="radio-5"]:checked ~ .glider {
      transform: translateX(400%);
    }
    .tab-container .glider {
      position: absolute;
      display: flex;
      height: 45px;
      width: 150px;
      background-color: #c1dcf1;
      z-index: 1;
      border-radius: 99px;
      transition: 0.25s ease-out;
    }
    .carousel-desktop {
      display: block;
    }
    .carousel-mobile {
      display: none;
    }
    @media (max-width: 767px) {
      .carousel-desktop {
        display: none;
      }
      .carousel-mobile {
        display: block;
      }
    }
    /* Mobile: upload cards fill slide for responsive size (like original) */
    .carousel-mobile .upload-card-mobile-wrap {
      width: 100% !important;
      height: 100% !important;
      max-width: 100%;
      min-height: 0;
    }
    /* Mobile: smaller font and icon to fit responsive card size */
    .carousel-mobile .upload-card-mobile-wrap .title {
      font-size: 1.25rem !important;
    }
    .carousel-mobile .upload-card-mobile-wrap img {
      max-width: 90px !important;
      max-height: 100px !important;
    }
    @media (max-width: 700px) {
      .tab-container .tabs {
        transform: scale(0.8);
      }
    }

    /* .carousel .slides>div>div>div {
        height: 8rem;
        width: 8rem;
      } */
    .defaultPdfWrap {
      padding: 2rem;
      background: #edf2f6;
      position: relative;
      border-radius: 10px;
      margin-top: 30px;
      /* max-width: 768px;
        margin: auto; */
    }
    .defaultPdfWrap h2 {
      position: relative;
      font-size: 1.5em;
      margin-bottom: 10px;
      font-weight: 500;
    }
    .defaultPdfWrap .carousel > ul {
      display: none;
    }
    .carousel .slides .item,
    .carousel .slides .firstItem {
      width: 100%;
      height: 100%;
      padding-right: 10%;
    }
    .carousel .slides .item > div,
    .carousel .slides .firstItem > div {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      overflow: hidden;
      border-radius: 10px;
    }
    /* Upload cards: no white parent background, allow overflow so hover border/lift aren't clipped */
    .carousel .slides .firstItem > div,
    .carousel .slides .item.upload-card-item > div {
      background: transparent;
      overflow: visible;
    }
    .carousel .slides .item > div:hover,
    .carousel .slides .firstItem > div:hover {
      border: 0px solid rgb(255, 255, 255);
    }
    /* Upload cards: more rounded corners, border and hover on inner card so top border isn't clipped */
    .carousel .slides .firstItem > div > div,
    .carousel .slides .item.upload-card-item > div > div {
      border-radius: 24px !important;
      border: 1px solid transparent;
      transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
    }
    .carousel .slides .firstItem > div:hover > div,
    .carousel .slides .item.upload-card-item > div:hover > div {
      border-color: rgba(255, 255, 255, 0.377) !important;
      box-shadow: 0 8px 24px rgba(59, 130, 246, 0.15);
      transform: translateY(-3px);
    }
    .carousel .slides .title {
      position: absolute;
      bottom: 0;
      width: 100%;
      text-align: center;
      background: rgba(0, 0, 0, 0.5);
      padding: 10px;
      color: #fff;
    }
    /* Upload card: keep title in flow so it sits directly under the icon */
    .carousel .slides .firstItem .title,
    .carousel .slides .upload-card-item .title {
      position: static;
      bottom: auto;
      width: auto;
      background: transparent;
      padding: 0;
      color: #000000;
      font-weight: normal;
    }
    .carousel .slides .item img {
      max-width: 100%;
    }
    .carousel .slides > div {
      display: flex;
    }
    .carousel span {
      display: inline-block;
      background: #b7d0f9;
      padding: 10px;
      border-radius: 100px;
    }
    .shadow-lg.p-5 {
      margin-top: 1rem !important;
    }
    .logged-out .carousel {
      max-width: 50%;
    }
    .logged-out .video {
      max-width: 50%;
    }
    @media (max-width: 1279px) {
      .logged-out .video iframe {
        max-height: 275px !important;
      }
    }
    @media (max-width: 1023px) {
      .logged-out .video iframe {
        max-height: 200px !important;
      }
    }
    .carousel .right {
      right: -50px !important;
    }
    .carousel .left {
      left: -50px !important;
    }
    @media (max-width: 767px) {
      .logged-out .video iframe {
        max-height: 300px !important;
      }
      .logged-out .carousel {
        max-width: 100%;
      }
      .logged-out .video {
        max-width: 100%;
        margin-top: 20px;
        padding-right: 25px;
      }
      .carousel .right {
        right: 8px !important;
      }
      .carousel .left {
        left: 8px !important;
      }
    }
    @media (max-width: 1045px) {
      .signaturetab {
        position: fixed;
        top: 68px;
        width: calc(100% - 10px);
      }
    }
    .logged-out {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-wrap: wrap;
    }
    /* .slides>div>div:nth-child(1),.slides>div>div:nth-child(2),.slides>div>div:nth-child(3),.slides>div>div:nth-child(4){
        opacity: 0;
      } */
    .tutorialWrap {
      height: 100vh;
      position: fixed;
      background: rgba(0, 0, 0, 0.1);
      top: 0px;
      left: 0px;
      z-index: 99;
    }
    .text-container {
      flex-grow: 1; /* Pushes button down */
    }

    .next-button-container {
      width: 100%;
      display: flex;
      justify-content: center; /* Center horizontally */
      margin-top: auto; /* Push it to the bottom */
      padding-top: 10px; /* Small default space */
    }
    .next-btn {
      padding: 10px 20px;
      font-size: 14px;
      font-weight: bold;
      color: white;
      background-color: #007bff;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      transition: background-color 0.3s ease, transform 0.2s ease;
    }

    .next-btn:hover {
      background-color: #0056b3;
      transform: scale(1.05);
    }

    .next-btn:active {
      transform: scale(0.95);
    }
    .step {
      background: #edf2f6;
      padding: 2em;
      border-radius: 15px;
      max-width: 350px;
      display: flex;
      flex-direction: column;
      justify-content: space-between; /* Ensures button is pushed to bottom */
      align-items: center;
      text-align: center;
      min-height: 350px; 
      margin: auto; /* Centers the entire div */
      /* Ensures enough space for text + button */
    }
    .step.step2 {
      position: absolute;
      left: 50%;
      bottom: 50px;
      flex-direction: row;
      z-index: 999;
    }
    .step.step2.tutorial1 {
      position: absolute;
      left: 30%;
      bottom: 50px;
      flex-direction: row;
      z-index: 999;
    }
    .step.step3,
    .step.step3.tutorial1 {
      max-width: 800px;
      left: 40%;
      top: 80px;
      position: absolute;
      flex-direction: row;
      z-index: 999;
    }
    .step.step4 {
      position: fixed;
      left: 40%;
      top: 80px;
      flex-direction: row;
      z-index: 999;
      padding: 15px;
      width: 300px;
    }
    .step.step5,
    .step.step6 {
      position: fixed;
      left: 50%;
      top: 80px;
      flex-direction: row;
      z-index: 999;
      padding: 15px;
      width: 300px;
    }
    .step.step6.tutorial1 {
      position: fixed;
      left: 70%;
      top: 80px;
      flex-direction: row;
      z-index: 999;
      padding: 15px;
      width: 300px;
    }
    .step.step2 img,
    .step.step3 img,
    .step.step4 img {
      width: 80px;
      margin-right: 20px;
    }
    .step h1 {
      font-size: 1.7em;
    }
    .step p {
      font-size: 1.2em;
      text-align: center;
    }

    .step.step2,
    .step.step2.tutorial1,
    .step.step3,
    .step.step3.tutorial1,
    .step.step4,
    .step.step5,
    .step.step6,
    .step.step6.tutorial1 {
      flex-direction: column; /* Make sure content stacks vertically */
      align-items: center; /* Keep everything centered */
      text-align: center;
    }

    .border-green {
      border: 3px solid #00ef00;
    }
    .slides .border-green {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .tabs.mobile {
      display: none;
    }
    .g-m-btn {
      padding: 5px 10px;
      background: #d1d6f6;
      border-radius: 10px;
      margin: 5px 20px 0 0;
    }
    @media screen and (max-width: 767px) {
      .step {
        width: 90vw !important;
        left: 5vw !important;
        top: 250px !important;
      }
      .delete-sign {
        max-width: 20px;
        max-height: 20px;
      }
      .signItem .action {
        flex-direction: column;
        align-items: flex-start;
      }
      .tabs.desktop {
        display: none;
      }
      .tabs.mobile {
        display: flex;
      }
    }
    .chat-page-header__user-icon {
      width: 28px;
      height: auto;
      aspect-ratio: 1 / 1;
      border-radius: 50%;
      cursor: pointer;
      transition: opacity 0.25s;
    }
    .templateImg {
      border: 2px solid gray;
      border-radius: 10px;
    }
    .templateImg.loaded {
      border-color: #4299e1;
    }
    .deleteEditTemp {
      max-width: 16px;
      position: absolute;
      top: -8px;
      left: calc(50% - 8px);
      background: #fff;
      border-radius: 50%;
    }
    .has_sub_menu .sub {
      display: none;
    }
    .has_sub_menu:hover .sub {
      display: block;
    }
  </style>
  <SignContextMenu
    bind:showMenu={showMenu}
    {previewMode}
    {pos}
    {quickSigns}
    {blog}
    {entry_requireds}
    {entry_options}
    on:close={closeMenu}
    on:addSignImage={(e) => addSignImage('', e.detail.position)}
    on:addQuickSignImage={(e) => addQuickSignImage(e.detail.url, e.detail.position)}
    on:addTextField={(e) => addTextField(e.detail.text, e.detail.positioned)}
  />
  <ShareFlow
    {previewMode}
    bind:sharePanel
    bind:usersPanel
    bind:uploadToFluentCase
    bind:uploadedToFluentCase
    bind:matterId
    bind:sendPDFType
    {twilioEnabled}
    {sendingSign}
    bind:sendPDFRes
    bind:selectedChatUser
    bind:fluentCaseEnabled
    bind:clipboardTxt
    bind:users
    bind:chatUsers
    bind:emailSubject
    bind:emailCC
    bind:friends
    bind:merusToken
    bind:merusCaseEnabled
    bind:fluentCaseToken
    bind:checkIfEmail
    {user}
    bind:newUserPanel
    bind:display_name_panel
    bind:sendingNewUser
    bind:sendingNewUserType
    bind:emailPanel
    bind:smsLang
    {languages}
    bind:userName
    bind:userPhone
    bind:newUserName
    on:closeShare={handleClickOutsideSharePanel}
    on:closeUsers={closeUsersPanel}
    on:uploadFluentCase={postPdfFluentCase}
    on:copy={copy}
    on:checkAllObjects={checkallObjects}
    on:chatUserSelect={handleChatUserSelect}
    on:sendSms={handleSendSMS}
    on:itemAdded={handleItemAdded}
    on:itemUpdated={handleItemUpdated}
    on:continueSend={continueSendSignature}
    on:showEmail={(e) => showEmailPanel(e.detail.open)}
    on:chatUserEnterEmail={handleChatUserEnterEmail}
    on:sendEmail={handleSendEmail}
    on:languageSelect={handleLanguageSelect}
    on:hideNewUser={hideNewUserPanel}
    on:checkUserPhone={checkUserPhone}
    on:addNewUser={addNewUser}
    on:sendSignature={() => sendSignature(0)}
    on:sendPdf={(e) => sendPDFfunc(e.detail.type)}
    on:download={savePDF}
  />

    <main
    bind:this={pdfWrap}
    class="flex flex-col items-center py-16 bg-gray-100 min-h-screen"
    style="padding-top: 5rem; padding-bottom: 0;"
  >
    <Background />
    {#if previewMode}
      <SignPreviewHeader
        showSignButton={!signedContactId}
        showDownloadButton={!!signedContactId}
        downloading={saving}
        on:back={onBack}
        on:sign={onSignDocument}
        on:download={savePDF}
      />
    {:else}
    <SignEditorHeader
      bind:selectedPageIndex
      bind:tutorialStep
      bind:tutorialNumber
      bind:signatureMenu
      bind:packetMenu
      bind:addTextMenu
      bind:quickSigns
      {blog}
      bind:templates
      bind:multiplePdfs
      {entry_requireds}
      {entry_options}
      bind:pdfName
      bind:user
      bind:newProfilePanel
      bind:searchKeyPending
      bind:pendingSignature
      bind:signatureTabLoading
      bind:friends
      bind:showArchive
      bind:completedSignature
      bind:emailNotifyAvailable
      bind:searchKeyCompleted
      bind:completedArchived
      bind:sendToId
      bind:showSignatureTab
      bind:completedPDFUrl
      bind:loadingTemplate
      bind:chatUsers
      bind:users
      bind:merusToken
      bind:pdfFile
      bind:pages
      bind:allObjects
      bind:pagesScale
      bind:editTemplatesAvailable
      bind:processingSaveTemplate
      bind:completedSaveTemplate
      bind:selectedMerusUserId
      bind:selectedMerusActivityTypeId
      bind:selectedSharepoint
      bind:signColor
      bind:templateId
      bind:pdfBlobFile
      bind:pdfFiles
      bind:tempThumb
      bind:sendPDFType
      bind:layerPos
      bind:currentFont
      bind:teamViewCompletedDocAvailable
      bind:shareSettingsAvailable
      bind:searchKeyFriend
      bind:inviteFriendPanel
      bind:inviteClipboardTxt
      bind:clipboardTxt
      bind:merusCaseEnabled
      bind:fileVineEnabled
      bind:fluentCaseEnabled
      bind:fluentCaseToken
      bind:microsoftSharepointTenantId
      bind:activeTab
      bind:emailSubject
      bind:twilioEnabled
      displayLeftMenuFunc={displayLeftMenuFunc}
      openLeftMenu={openLeftMenu}
      closeLeftMenu={closeLeftMenu}
      onUploadPDF={onUploadPDF}
      onUploadImage={onUploadImage}
      showPacketMenu={showPacketMenu}
      showAddTextMenu={showAddTextMenu}
      showSignatureMenu={showSignatureMenu}
      onAddDrawing={onAddDrawing}
      addSignImage={addSignImage}
      addQuickSignImage={addQuickSignImage}
      addTextField={addTextField}
      handleClickOutsideSignatureMenu={handleClickOutsideSignatureMenu}
      handleClickOutsideAddTextMenu={handleClickOutsideAddTextMenu}
      deleteTemplate={deleteTemplate}
      loadExtraTemplate={loadExtraTemplate}
      shareFunc={shareFunc}
      showNewProfileFunc={showNewProfileFunc}
      showLoginPopup={showLoginPopup}
      handleLoadTemplate={handleLoadTemplate}
    />
    {/if}
        {#if selectedPageIndex < 0 && !previewMode}
      <div class="container">
        {#if user.id != ""}
          <div class="defaultPdfWrap" data-testid="get-started-section">
            {#if isMobile}
            <div
              class="get-started-mobile"
              class:get-started-mobile--open={getStartedOpen}
              data-testid="get-started-mobile"
            >
              <button
                type="button"
                class="mobile-get-started-toggle"
                class:mobile-get-started-toggle--open={getStartedOpen}
                data-testid="get-started-toggle"
                aria-expanded={getStartedOpen}
                aria-controls="mobile-get-started-panel"
                on:click={toggleGetStarted}
              >
                <span class="mobile-get-started-toggle__text">
                  <span class="mobile-get-started-toggle__title">Get Started</span>
                  <span class="mobile-get-started-toggle__sub">Click to view videos and tutorials</span>
                </span>
                <span class="mobile-get-started-toggle__chevron" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 9l6 6 6-6"/>
                  </svg>
                </span>
              </button>
              {#if getStartedOpen}
              <div
                id="mobile-get-started-panel"
                class="mobile-get-started-panel"
                data-testid="get-started-panel"
                transition:slide={{ duration: 280, easing: quintOut }}
                on:introend={onGetStartedIntroEnd}
                on:outrostart={onGetStartedOutroStart}
              >
                {#if getStartedCarouselReady}
                {#key getStartedCarouselKey}
                <Carousel perPage={1} loop={false} draggable={true} dots={false}>
                  <div class="video firstItem">
                    <div class="get-started-video-frame">
                      <iframe
                        src="https://www.youtube.com/embed/7m7ENMzBkyo?playsinline=1&rel=0"
                        title="Sign Documents using Gmail / LegalPal Signature Software"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                        loading="eager"
                      ></iframe>
                    </div>
                  </div>
                  <div class="video">
                    <div class="get-started-video-frame">
                      <iframe
                        src="https://www.youtube.com/embed/KZtzvJdFaVc?playsinline=1&rel=0"
                        title="Sign Documents using Microsoft Outlook / LegalPal Signature Software"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                        loading="eager"
                      ></iframe>
                    </div>
                  </div>
                  <span slot="left-control">
                    <img src="/img/left-arrow-svgrepo-com.svg" alt="" />
                  </span>
                  <span slot="right-control">
                    <img src="/img/right-arrow-svgrepo-com.svg" alt="" />
                  </span>
                </Carousel>
                {/key}
                {:else}
                <div class="get-started-video-placeholder" data-testid="get-started-video-placeholder" aria-hidden="true"></div>
                {/if}
                <div class="tutorials-mobile" style="margin-top:1rem;">
                  <div class="flex items-center mb-2 flex-wrap gap-2">
                    <h2 class="font-bold text-lg mr-3" style="margin-bottom:0;">Tutorials</h2>
                    <input
                      type="text"
                      placeholder="Search"
                      class="border rounded px-2 py-1 text-sm"
                      style="background: #e9eef6; max-width: 100%;"
                      bind:value={searchTutorial}
                    />
                  </div>
                  <ul class="space-y-3">
                    {#each tutorials.filter(t => !searchTutorial || t.title.toLowerCase().includes(searchTutorial.toLowerCase())) as tutorial}
                      <li>
                        <span
                          class="text-blue-700 hover:underline cursor-pointer text-base font-semibold"
                          style="font-size: 1.0rem;"
                          on:click={() => startTutorial(tutorial.id)}
                        >{tutorial.title}</span>
                      </li>
                    {/each}
                  </ul>
                </div>
              </div>
              {/if}
            </div>
            {:else}
            <div class="get-started-desktop" data-testid="get-started-desktop">
            <div class="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
              <div class="flex-1 min-w-0 w-full md:w-auto">
                <h2>Get Started</h2>
                <Carousel perPage="1.2" loop={false} draggable={true} >
                  <div class="video firstItem">
                    <iframe
                      width="1250"
                      height="703"
                      src="https://www.youtube.com/embed/7m7ENMzBkyo?si=ld3iLqe-uN-TyNxu"
                      title="Sign Documents using Gmail / LegalPal Signature Software"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                      style="max-width: 100%; max-height: 350px; border-radius: 10px;"
                    ></iframe>
                  </div>
                  <div class="video">
                    <iframe
                      width="1250"
                      height="703"
                      src="https://www.youtube.com/embed/KZtzvJdFaVc?si=ixxs9oIAY14PTWrz"
                      title="Sign Documents using Microsoft Outlook / LegalPal Signature Software"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                      style="max-width: 100%; max-height: 350px; border-radius: 10px;"
                    ></iframe>
                  </div>
                  <span slot="left-control">
              <img src="/img/left-arrow-svgrepo-com.svg" alt="" />
                  </span>
                  <span slot="right-control">
              <img src="/img/right-arrow-svgrepo-com.svg" alt="" />
                  </span>
                </Carousel>
              </div>
                <div class="flex-shrink-0 w-full md:w-auto" style="min-width:50%;max-width:50%;min-height: 100%;">
                    <div class="flex items-center mb-2">
                      <h2 class="font-bold text-lg mr-3" style="margin-bottom:0;">Tutorials</h2>
                      <div class="relative">
                        <input
                          type="text"
                          placeholder="Search"
                          class="border rounded px-2 py-1 text-sm w-40"
                          style="background: #e9eef6;"
                          bind:value={searchTutorial}
                        />
                      </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-6 mt-2">
                      {#each [
                        tutorials.filter(t => !searchTutorial || t.title.toLowerCase().includes(searchTutorial.toLowerCase())).slice(0, 4),
                        tutorials.filter(t => !searchTutorial || t.title.toLowerCase().includes(searchTutorial.toLowerCase())).slice(4, 7),
                        tutorials.filter(t => !searchTutorial || t.title.toLowerCase().includes(searchTutorial.toLowerCase())).slice(7)
                      ] as col}
                        <ul class="space-y-6">
                          {#each col as tutorial}
                            <li>
                                <span
                                class="text-blue-700 hover:underline cursor-pointer text-base font-semibold"
                                style="font-size: 1.0rem;"
                                on:click={() => startTutorial(tutorial.id)}
                                >{tutorial.title}</span>
                            </li>
                          {/each}
                        </ul>
                      {/each}
                    </div>
                </div>
            </div>
            </div>
            {/if}
          </div>
        {/if}
          
        <div class="defaultPdfWrap">
          <div class="flex items-center">
            <h2>Start a New Document</h2>
            <!-- <button
              on:click={() => displayTutorialPage()}
              class="py-1 px-3 rounded"
              style="border: 1px solid #000;display: flex;background: #eee;margin-left: 15px; margin-bottom: 10px;min-width: 110px;"
            >
              <img
                alt=""
                src="/info.svg"
                style="width: 25px; margin-right: 5px;"
              /> Tutorial
            </button> -->
          </div>
          {#if user.id != ""}
            {#if isMobile}
            <div class="mobile-doc-grid" data-testid="upload-carousel-mobile">
              <label for="pdf" class="mobile-doc-tile" data-testid="upload-pdf-label">
                <img alt="" src="upload_card.png" />
                <span class="mobile-doc-tile__title">Upload</span>
              </label>
              <div class="mobile-doc-tile" role="button" tabindex="0">
                <img alt="" src="combine.png" />
                <span class="mobile-doc-tile__title">Combine</span>
              </div>
              <div class="mobile-doc-tile" role="button" tabindex="0">
                <img alt="" src="merge.png" />
                <span class="mobile-doc-tile__title">Merge</span>
              </div>
              <div class="mobile-doc-tile" role="button" tabindex="0">
                <img alt="" src="court.png" />
                <span class="mobile-doc-tile__title">Court</span>
              </div>
            </div>
            {:else}
            <div class="carousel-desktop" data-testid="upload-carousel-desktop">
              <Carousel perPage="4" loop={false} draggable={false}>
                <div class="firstItem upload-card-item" for="pdf">
                  <div style="width:273.6px;height:354.062px;box-sizing:border-box;margin:0 auto;">
                    <div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#e6f7ff;border-radius:14px;padding:18px;">
                      <label for="pdf" class="cursor-pointer" style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;">
                        <img alt="" src="upload_card.png" style="display:block;margin:0 auto;max-width:140px;max-height:160px;object-fit:contain;" />
                        <div class="title" class:border-green={tutorialStep == 2 && (tutorialNumber == 1 || tutorialNumber == 2 || tutorialNumber == 8 || tutorialNumber == 9)} style="text-align:center;font-size:2.375rem;color:#000000;">Upload</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="item upload-card-item">
                  <div style="width:273.6px;height:354.062px;box-sizing:border-box;margin:0 auto;">
                    <div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#e6f7ff;border-radius:14px;padding:18px;">
                      <div style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;cursor:default;">
                        <img alt="" src="combine.png" style="display:block;margin:0 auto;max-width:140px;max-height:160px;object-fit:contain;" />
                        <div class="title" class:border-green={tutorialStep == 2 && (tutorialNumber == 1 || tutorialNumber == 2 || tutorialNumber == 8 || tutorialNumber == 9)} style="text-align:center;font-size:2.375rem;color:#000000;">Combine</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item upload-card-item">
                  <div style="width:273.6px;height:354.062px;box-sizing:border-box;margin:0 auto;">
                    <div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#e6f7ff;border-radius:14px;padding:18px;">
                      <div style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;cursor:default;">
                        <img alt="" src="merge.png" style="display:block;margin:0 auto;max-width:140px;max-height:160px;object-fit:contain;" />
                        <div class="title" class:border-green={tutorialStep == 2 && (tutorialNumber == 1 || tutorialNumber == 2 || tutorialNumber == 8 || tutorialNumber == 9)} style="text-align:center;font-size:2.375rem;color:#000000;">Merge</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="item upload-card-item">
                  <div style="width:273.6px;height:354.062px;box-sizing:border-box;margin:0 auto;">
                    <div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#e6f7ff;border-radius:14px;padding:18px;">
                      <div style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;cursor:default;">
                        <img alt="" src="court.png" style="display:block;margin:0 auto;max-width:140px;max-height:160px;object-fit:contain;" />
                        <div class="title" class:border-green={tutorialStep == 2 && (tutorialNumber == 1 || tutorialNumber == 2 || tutorialNumber == 8 || tutorialNumber == 9)} style="text-align:center;font-size:2.375rem;color:#000000;">Court</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <span slot="left-control">
                  <img src="/img/left-arrow-svgrepo-com.svg" alt="" />
                </span>
                <span slot="right-control">
                  <img src="/img/right-arrow-svgrepo-com.svg" alt="" />
                </span> -->
              </Carousel>
            </div>
            {/if}
          {:else}
            {#if isMobile}
            <div class="mobile-doc-grid mobile-doc-grid--logged-out" data-testid="upload-carousel-mobile">
              <label for="pdf" class="mobile-doc-tile" data-testid="upload-pdf-label">
                <img alt="" src="upload_card.png" />
                <span class="mobile-doc-tile__title">Upload</span>
              </label>
              <button
                type="button"
                class="mobile-doc-tile"
                on:click={() => loadDefaultDoc(1)}
              >
                <img alt="" src="/pdf-imgs/Fee_Disclosure_Statement.png" />
                <span class="mobile-doc-tile__title mobile-doc-tile__title--sm">{defaultDocs[1]}</span>
              </button>
            </div>
            {:else}
            <div class="logged-out flex items-center" data-testid="upload-carousel-desktop">
              <Carousel perPage="2" loop={false}>
                <div class="firstItem" for="pdf">
                  <div style="width:273.6px;height:354.062px;box-sizing:border-box;margin:0 auto;">
                    <div style="width:100%;height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;background:#e6f7ff;border-radius:14px;padding:18px;">
                      <label for="pdf" class="cursor-pointer" style="width:100%;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;">
                        <img alt="" src="upload_card.png" style="display:block;margin:0 auto;max-width:140px;max-height:160px;object-fit:contain;" />
                        <div class="title" class:border-green={tutorialStep == 2 && (tutorialNumber == 1 || tutorialNumber == 2 || tutorialNumber == 8 || tutorialNumber == 9)} style="text-align:center;font-size:2.375rem;color:#000000;">Upload</div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="item">
                  <div>
                    <img src="/pdf-imgs/Fee_Disclosure_Statement.png" />
                    <div
                      class="title cursor-pointer"
                      class:border-green={tutorialStep == 2 && tutorialNumber == 0}
                      on:click={() => loadDefaultDoc(1)}
                    >
                      {defaultDocs[1]}
                    </div>
                  </div>
                </div>
              </Carousel>
              <div class="video">
                <iframe
                  width="1250"
                  height="703"
                  src="https://www.youtube.com/embed/_97qERhog0U?si=GD4CZ9blAEBGgTFo"
                  title="LegalPal Signature Software - Official Trailer"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                  style="max-width: 100%; max-height: 350px; border-radius: 10px;"
                ></iframe>
              </div>
            </div>
            {/if}
          {/if}
          {#if tutorialStep == 2 && tutorialNumber == 0}
            <div
              class="step step2 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Select a new document.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}
          {#if tutorialStep == 2 && (tutorialNumber == 1 || tutorialNumber == 2)}
            <div
              class="step step2 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Upload a PDF by either drag or drop or click â€˜Upload New PDFâ€™.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 2 && (tutorialNumber == 3)}
            <div
              class="step step2 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Packet</h1>
                <p>Group Templates into a Packet to be completed/signed simultaneously.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 2 && (tutorialNumber == 4 || tutorialNumber == 5)}
            <div
              class="step step2 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Click on the Profile menu and Open the Templates tab.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 2 && (tutorialNumber == 6)}
            <div
              class="step step2 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Click on the Profile menu and Open the Team tab.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 2 && (tutorialNumber == 7)}
            <div
              class="step step2 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Click on the Profile menu and Open the Completed documents tab.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 2 && (tutorialNumber == 8 || tutorialNumber == 9)}
            <div
              class="step step2 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Open a new PDF document. </p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 3 && (tutorialNumber == 3)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 1:</h1>
                <p>Open the Templates tab.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 3 && (tutorialNumber == 4)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 2:</h1>
                <p>Each Template has an â€œAutomationâ€ button. The automation button opens the Automation menu.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 3 && (tutorialNumber == 5)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 2:</h1>
                <p>Each Template for Microsoft users can share completed documents automatically to their SharePoint.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 3 && (tutorialNumber == 6)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 2:</h1>
                <p>Share the invitation link.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 3 && (tutorialNumber == 7)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 2:</h1>
                <p>Click the â€˜Archivedâ€™ button to open Archived documents.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 4 && (tutorialNumber == 3)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 2:</h1>
                <p>Press â€œCreate Packet +â€ button.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 4 && (tutorialNumber == 4)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 3:</h1>
                <p>By assigning an Activity ID to the Template you can generate an Activity in the case file that would trigger a workflow. </p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 4 && (tutorialNumber == 5)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 3:</h1>
                <p>To send copies of Completed Documents to Sharepoint insert a valid Sharepoint endpoint link.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 4 && (tutorialNumber == 7)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 3:</h1>
                <p>Documents are automatically archived after 90 days.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
              </div>
            </div>
          {/if}



          {#if tutorialStep == 5 && (tutorialNumber == 3)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 3:</h1>
                <p>Now select the Templates</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}  

          
          {#if tutorialStep == 5 && (tutorialNumber == 4)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 4:</h1>
                <p>By assigning a User ID to the Template, you can generate an Event in the case file assigned to the User with the matching User ID. </p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
              </div>
            </div>
          {/if}

          {#if tutorialStep == 6 && (tutorialNumber == 3)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 4:</h1>
                <p>Name the Packet â€œSample Packetâ€ and Save</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}
          {#if tutorialStep == 7 && (tutorialNumber == 3)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 5:</h1>
                <p>Select the New Packet</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
              </div>
            </div>
          {/if}
          {#if tutorialStep == 8 && (tutorialNumber == 3)}
            <div
              class="step step6 tutorial1 cursor-pointer"
            >
              <img alt="" src="/EmoteHi.gif" />
              <div>
                <h1>Step 6:</h1>
                <p>You can now Share/Edit/Delete the new packet.</p>
              </div>
              <div class="next-button-container">
                <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
              </div>
            </div>
        {/if}
          {#if tutorialPanel}
          <div 
            class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50"
          >
            <div class="bg-white p-6 text-center w-[350px] rounded-lg shadow-lg relative">
              <!-- Close Button -->
              <div class="flex justify-end">
                <button 
                  class="text-gray-500 hover:text-gray-700 text-xl"
                  on:click={() => tutorialPanel = false}
                >âœ•</button>
              </div>
        
              <!-- Header -->
              <h1 class="text-xl font-bold">Welcome to the tutorial</h1>
              <div class="flex justify-center">
                <img alt="" src="/EmoteHi.gif" />
              </div>
              <p class="text-gray-600 mb-4">Select a tutorial to start</p>
        
              <!-- Tutorial List -->
              <ul class="text-left space-y-2">
                {#each tutorials as tutorial}
                  <li class="flex justify-between items-center">
                    <span class="text-sm text-gray-800">{tutorial.title}</span>
                    <button 
                      class="bg-blue-500 hover:bg-blue-700 text-white text-xs font-bold py-1 px-3 rounded"
                      on:click={() => startTutorial(tutorial.id)}
                    >Start</button>
                  </li>
                {/each}
              </ul>
            </div>
          </div>
        {/if}
        
        </div>
        {#if templates.length > 0}
          <div class="defaultPdfWrap" data-testid="templates-section">
            <h2>Templates</h2>
            {#if isMobile}
              <div class="mobile-templates-strip" data-testid="templates-carousel-mobile">
                {#each templates as template}
                  <button
                    type="button"
                    class="mobile-template-card"
                    on:click={() => loadTemplate(template)}
                  >
                    <img alt="" src={template.thumbnail} />
                    <span class="mobile-template-card__title">{template.pdfName}</span>
                  </button>
                {/each}
              </div>
            {:else}
              <div class="carousel-desktop" data-testid="templates-carousel-desktop">
                <Carousel perPage="4" loop={false}>
                  {#each templates as template}
                    <div class="item">
                      <div>
                        <img alt="" src={template.thumbnail} />
                        <div
                          class="title cursor-pointer"
                          on:click={() => loadTemplate(template)}
                        >
                          {template.pdfName}
                        </div>
                      </div>
                    </div>
                  {/each}
                </Carousel>
              </div>
            {/if}
          </div>
        {/if}
      </div>
    {/if}
    {#if addingDrawing}
      <div
        transition:fly={{ y: -200, duration: 500 }}
        class="sign-drawing-overlay fixed z-10 top-0 left-0 right-0 border-b border-gray-300 bg-white
          shadow-lg"
        style="height: 50%;"
      >
        <DrawingCanvas
          on:finish={(e) => {
            const { originWidth, originHeight, path } = e.detail;
            let scale = 1;
            if (originWidth > 500) {
              scale = 500 / originWidth;
            }
            addDrawing(originWidth, originHeight, path, scale);
            addingDrawing = false;
          }}
          on:cancel={() => (addingDrawing = false)}
        />
      </div>
    {/if}
    <SignLoginPanel
      bind:loginPanel
      bind:twoFactAuthPanel
      bind:loginError
      bind:verificationCode
      on:close={() => (loginPanel = false)}
    />
        {#if pages.length}
      <div class="sign-pdf-download-bar flex justify-center px-5 w-full mb-4" data-testid="sign-pdf-download-bar">
        <button
          on:click={savePDF}
          class="w-30 bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-3
            md:px-4 mr-3 md:mr-4 rounded"
          class:cursor-not-allowed={pages.length === 0 || saving || !pdfFile}
          class:bg-blue-700={pages.length === 0 || saving || !pdfFile}
          data-testid="pdf-download-button"
        >
          {saving ? "DOWNLOADING" : "DOWNLOAD"}
        </button>
        {#if user.id != ""}
          <label class="flex items-center justify-center h-full w-20">
            {user.name}
          </label>
          <button
            on:click={showSignatureTab}
            class="w-10 py-1 flex items-center justify-center"
          >
            <img alt="" src="/menu.png" />
          </button>
        {/if}
      </div>
      <div class="sign-pdf-rename-bar flex justify-center px-5 w-full md:hidden" data-testid="sign-pdf-rename-bar">
        <img src="/edit.svg" class="mr-2" alt="a pen, edit pdf name" />
        <input
          placeholder="Rename your PDF here"
          type="text"
          class="flex-grow bg-transparent"
          bind:value={pdfName}
        />
      </div>

      {#if tutorialStep == 3 && tutorialNumber == 0}
        <div
          class="step step3 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 2:</h1>
            <p>Add a Signature<br />to the Document.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 3 && tutorialNumber == 1}
        <div
          class="step step3 tutorial1 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 2:</h1>
            <p>Right-click and select â€˜Get Signatureâ€™.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 3 && tutorialNumber == 2}
      <div
        class="step step3 tutorial1 cursor-pointer"
      >
        <img alt="" src="/EmoteHi.gif" />
        <div>
          <h1>Step 2:</h1>
          <p>Place a Signature line, Name, and Date.</p>
        </div>
        <div class="next-button-container">
          <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
        </div>
      </div>
    {/if}

      {#if tutorialStep == 4 && tutorialNumber == 0}
        <div
          class="step step4 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 3:</h1>
            <p>Add a Name<br />to the Document.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 4 && tutorialNumber == 1}
        <div
          class="step step4 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 3:</h1>
            <p>Place the Signature field on the Signature line</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 4 && tutorialNumber == 2}
      <div
        class="step step4 cursor-pointer"
      >
        <img alt="" src="/EmoteHi.gif" />
        <div>
          <h1>Step 3:</h1>
          <p>Once the document is ready, click the Profile icon to open the menu.</p>
        </div>
        <div class="next-button-container">
          <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
        </div>
      </div>
    {/if}

    
    {#if tutorialStep == 3 && (tutorialNumber == 8)}
    <div
      class="step step6 tutorial1 cursor-pointer"
    >
      <img alt="" src="/EmoteHi.gif" />
      <div>
        <h1>Step 2:</h1>
        <p>Right-click to Add a Signature field. </p>
      </div>
      <div class="next-button-container">
        <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
      </div>
    </div>
    {/if}

    {#if tutorialStep == 3 && (tutorialNumber == 9)}
    <div
      class="step step6 tutorial1 cursor-pointer"
    >
      <img alt="" src="/EmoteHi.gif" />
      <div>
        <h1>Step 2:</h1>
        <p>Right-click to open the Tool Menu.</p>
      </div>
      <div class="next-button-container">
        <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
      </div>
    </div>
    {/if}

    {#if tutorialStep == 4 && (tutorialNumber == 8)}
      <div
        class="step step6 tutorial1 cursor-pointer"
      >
        <img alt="" src="/EmoteHi.gif" />
        <div>
          <h1>Step 3:</h1>
          <p>Right-click the Signature field to change the color.</p>
        </div>
        <div class="next-button-container">
          <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
        </div>
      </div>
    {/if}

    {#if tutorialStep == 4 && (tutorialNumber == 9)}
      <div
        class="step step6 tutorial1 cursor-pointer"
      >
        <img alt="" src="/EmoteHi.gif" />
        <div>
          <h1>Step 3:</h1>
          <p> Select â€˜Entryâ€™ optional or required.</p>
        </div>
        <div class="next-button-container">
          <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
        </div>
      </div>
    {/if}

    {#if tutorialStep == 5 && (tutorialNumber == 9)}
      <div
        class="step step6 tutorial1 cursor-pointer"
      >
        <img alt="" src="/EmoteHi.gif" />
        <div>
          <h1>Step 4:</h1>
          <p>The Entry fields will be added to the Web form for the Client to complete the document. </p>
        </div>
        <div class="next-button-container">
          <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Finish</button>
        </div>
      </div>
    {/if}
    
    {#if tutorialStep == 5 && tutorialNumber == 2}
    <div
      class="step step5 cursor-pointer"
    >
      <img alt="" src="/EmoteHi.gif" />
      <div>
        <h1>Step 4:</h1>
        <p>In the profile menu, navigate to the Templates tab.</p>
      </div>
      <div class="next-button-container">
        <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
      </div>
    </div>
  {/if}

      {#if tutorialStep == 5 && tutorialNumber == 1}
        <div
          class="step step5 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 4:</h1>
            <p>Click â€˜Shareâ€™ to sign the document by using either the Email or Link options.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 5 && tutorialNumber == 0}
        <div
          class="step step5 cursor-pointer"
          on:click={() => displayTutorial(6,0)}
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 4:</h1>
            <p>Share the Document.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 6 && tutorialNumber == 0}
        <div
          class="step step6 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 5:</h1>
            <p>Open the menu<br />to track your documents.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 6 && tutorialNumber == 1}
        <div
          class="step step6 tutorial1 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 5:</h1>
            <p>Then you can Check the status of the Document from the Profile menu.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 6 && tutorialNumber == 2}
        <div
          class="step step6 tutorial1 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 5:</h1>
            <p>In the templates tab there is a â€˜Save Templateâ€™ button.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(tutorialStep + 1, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}
  
      {#if tutorialStep == 7 && tutorialNumber == 1}
        <div
          class="step step6 cursor-pointer"
          on:click={() => displayTutorial(0,1)}
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 6:</h1>
            <p>When the document is successfully signed, you will be notified by email.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}

      {#if tutorialStep == 7 && tutorialNumber == 2}
        <div
          class="step step6 cursor-pointer"
        >
          <img alt="" src="/EmoteHi.gif" />
          <div>
            <h1>Step 6:</h1>
            <p>Your Template should now be saved. Open the Templates menu again to check. You can now Load/Edit/Share this new template.</p>
          </div>
          <div class="next-button-container">
            <button class="next-btn" on:click={() => displayTutorial(0, tutorialNumber)}>Next</button>
          </div>
        </div>
      {/if}
      {#if !previewMode }
        <div
          class="sign-editor-actions"
          data-testid="sign-editor-actions"
          style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 16px;
          z-index: 1;
          width: 100%;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
        ">
          <!-- Back to Dashboard (left) -->
          <div style="flex: 1; display: flex; align-items: center;">
            <div class="sign-editor-actions__back-text" onclick="location.reload()" style="
              color: #4aa8ff;
              font-weight: 400;
              font-size: 16px;
              font-family: 'Quicksand', sans-serif;
              cursor: pointer;
              display: flex;
              align-items: center;
            ">
              <img src="arrow_back_blue.svg" alt="Back" style="width: 20px; height: 20px; margin-right: 6px;" />
              Back to Dashboard
            </div>
          </div>

          <!-- Save as Template (center) -->
          <div style="flex: 1; display: flex; justify-content: center;">
            {#if (user.id == user.appId || editTemplatesAvailable) && multiplePdfs.length == 0}
              {#if processingSaveTemplate}
                <button
                  class="whitespace-no-wrap py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4"
                  class:hidden={selectedPageIndex < 0}
                  style="border: 1px solid grey;"
                >
                  <img
                    alt=""
                    src="/loading.gif"
                    style="max-width: 30px;"
                  />
                </button>
              {:else if completedSaveTemplate}
                <CheckMark />
              {:else}
                <button
                  on:click={saveTemplate}
                  class="whitespace-no-wrap bg-blue-500 hover:bg-blue-700 text-white
                    font-bold py-1 px-3 md:px-4 rounded mr-3 cursor-pointer md:mr-4"
                  class:border-green={tutorialStep == 6 }
                  class:hidden={selectedPageIndex < 0}
                  data-testid="save-as-template-button"
                >
                  Save as Template
                </button>
              {/if}
            {/if}
            {#if isMobile && pages.length}
              <button
                on:click={savePDF}
                class="sign-editor-actions__download whitespace-no-wrap bg-blue-500 hover:bg-blue-700 text-white
                  font-bold py-1 px-3 rounded cursor-pointer"
                class:cursor-not-allowed={pages.length === 0 || saving || !pdfFile}
                class:bg-blue-700={pages.length === 0 || saving || !pdfFile}
                data-testid="pdf-download-button-mobile"
              >
                {saving ? "â€¦" : "Download"}
              </button>
            {/if}
          </div>

          <!-- Placeholder for right alignment (optional, for symmetry) -->
          <div style="flex: 1;"></div>
        </div>

      {/if}
      <SignPdfEditor
        {pages}
        {pagesScale}
        {allObjects}
        {selectedPageIndex}
        {previewMode}
        {onMeasure}
        {selectPage}
        {updateObject}
        {deleteObject}
        {selectFontFamily}
        {onRightClick}
      />
    {:else}
      <div class="w-full flex-grow flex justify-center items-center">
        <span class=" font-bold text-3xl text-gray-500"
          >Drag something here</span
        >
      </div>
    {/if}
    {#if loadingTemplate}
      <div
      class="fixed top-0 left-0 right-0 flex"
      style="height: 100vh;justify-content: center;align-items: center;z-index:99; background: {previewMode ? '#fff' : 'rgba(0,0,0,0.8)'};"
      >
      <img alt="" src="/loading.gif" style="max-width: 100px;" />
      </div>
    {/if}
    {#if !user.subscribed && user.signinCount == 5}
      <SubscribeView />
    {/if}
    <LeftMenu
      on:hide={() => closeLeftMenu()}
      display={displayLeftMenu}
      user_data={user}
    />
    <!-- Page Manipulation Toolbar - Fixed on Right (hidden for signedContact read-only preview) -->
    {#if pages.length > 0 && !signedContactId}
      <PageToolbar
        selectedPageIndex={selectedPageIndex}
        currentPageIndex={selectedPageIndex}
        pagesLength={pages.length}
        onAddPagesAbove={handleAddPagesAbove}
        onAddPagesBelow={handleAddPagesBelow}
        onSplicePage={splicePage}
        onDeletePage={deletePage}
        disabled={{
          splice: selectedPageIndex < 0,
          delete: selectedPageIndex < 0 || pages.length <= 1
        }}
      />
    {/if}
  </main>
{:else}
  <div
    class="w-full flex-grow flex justify-center items-center"
    style="height: 100vh;position: fixed;background: #fff;top: 0;left: 0;z-index: 99;"
  >
    <img alt="" src="/EmoteHi.gif" />
  </div>
{/if}
